<!-- Encabezado: qué es y, sobre todo, qué NO es (no guarda). -->
<div class="flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 px-6 py-4">
  <div class="flex items-center gap-3">
    <span
      class="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500/10 to-violet-500/10">
      <mat-icon class="icon-size-5 text-indigo-500" svgIcon="heroicons_outline:sparkles"></mat-icon>
    </span>
    <div>
      <div class="text-base font-bold text-slate-900">Sugerencia de optimización de rutas</div>
      <!-- Decir de dónde salen los pedidos evita que el conteo del modal parezca
           no cuadrar con el de la grilla, que muestra los conjuntos por separado. -->
      <div class="text-secondary text-xs">
        Con ruta y viaje + sin viaje · {{ data.loadDate | date: 'dd/MM/yyyy' }}
        <ng-container *ngIf="loadedScopeLabel"> · {{ loadedScopeLabel }}</ng-container>
        <!-- Se declara la antiguedad porque la huella no alcanza: puede coincidir y
             el plan estar viejo igual, si alguien asigno pedidos a un viaje sin
             tocar ningun filtro. No se puede saber sin volver a consultar. -->
        <span *ngIf="restoredAtLabel"
          class="ml-1 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold text-slate-600"
          title="Es la corrida anterior, no se volvio a calcular. Si asignaste pedidos a un viaje desde entonces, este plan no lo sabe.">
          calculado {{ restoredAtLabel }}
        </span>
      </div>
    </div>
  </div>
  <div class="flex items-center gap-2">
    <span class="rounded-full bg-amber-50 px-3 py-1 text-xs font-bold text-amber-700">
      Solo sugerencia · no modifica los viajes
    </span>
    <button mat-icon-button (click)="close()" aria-label="Cerrar">
      <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
    </button>
  </div>
</div>

<div mat-dialog-content class="flex flex-col gap-6 !px-6 !py-5">
  <!-- Paso 1: elegir oficinas. El modal NO calcula hasta tenerlas: una corrida
       recorre todos los pedidos del alcance y pega una vez al motor por
       sub-ruta, así que acotar antes evita pagarla para después descartarla. -->
  <div *ngIf="state === 'select'" class="flex flex-col gap-5 py-4">
    <div class="flex items-start gap-3 rounded-2xl border border-indigo-100 bg-indigo-50 p-4">
      <mat-icon class="icon-size-5 shrink-0 text-indigo-500" svgIcon="heroicons_outline:building-office-2"></mat-icon>
      <div class="text-sm text-indigo-900">
        <div class="font-semibold">Elige las oficinas de ventas a optimizar</div>
        <div class="text-xs text-indigo-700">
          Cada oficina es el almacén desde el que salen y al que vuelven sus camiones, y se
          planifica por separado. Se optimizan juntos los <b>pedidos con ruta y viaje</b> y los
          <b>pedidos sin viaje</b> del {{ data.loadDate | date: 'dd/MM/yyyy' }}: es la misma flota la
          que tiene que llevar ambos.
        </div>
      </div>
    </div>

    <div *ngIf="officesLoading" class="flex items-center gap-3 text-sm text-slate-600">
      <mat-spinner diameter="20"></mat-spinner>
      Cargando oficinas de ventas…
    </div>

    <!-- Controles del paso 1 EN PAREJAS: dos columnas para que el paso quepa sin
         desplazarse. Cada fila junta los dos controles de la misma pregunta:
         dónde se reparte (oficinas | territorios), quién reparte (camiones |
         atención), cuánto tiempo hay (franja | viajes) y qué entra (conjuntos). -->
    <div *ngIf="!officesLoading && officeOptions.length" class="grid gap-x-4 gap-y-3 md:grid-cols-2">
      <div class="flex flex-col">
        <mat-form-field appearance="fill" class="w-full" subscriptSizing="dynamic">
          <mat-label>Oficinas de ventas</mat-label>
          <mat-select [(ngModel)]="selectedOfficeIds" multiple (openedChange)="onOfficesClosed($event)">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="officeSearch" [ngModelOptions]="{ standalone: true }"
                placeholderLabel="Buscar oficina..." noEntriesFoundLabel="No se encontraron resultados"
                (ngModelChange)="filterOfficeOptions()">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let o of filteredOfficeOptions" [value]="o.id">
              <span *ngIf="o.externalKeys?.code" class="font-semibold">{{ o.externalKeys.code }} — </span>{{ o.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="mt-1 flex flex-wrap items-center gap-2">
          <button mat-stroked-button type="button" (click)="toggleAllOffices()">
            {{ allOfficesSelected ? 'Quitar todas' : 'Seleccionar todas' }}
          </button>
          <span class="text-secondary text-xs">
            {{ selectedOfficeIds.length }} de {{ officeOptions.length }} seleccionadas
          </span>
        </div>
      </div>

      <!-- Territorios de las oficinas elegidas, derivados de los `routes[]` de sus
           sub-rutas de ENTREGA (mismo maestro que master/routing/sub-route). Acota
           los pedidos de la corrida Y la flota. Todos elegidos = sin filtro. Si
           ninguna ruta de entrega declara territorio, el selector no aparece y
           manda el filtro de la pantalla. -->
      <div *ngIf="territoryOptions.length" class="flex flex-col">
        <mat-form-field appearance="fill" class="w-full" subscriptSizing="dynamic">
          <mat-label>Territorios</mat-label>
          <mat-select [(ngModel)]="selectedTerritoryIds" multiple (openedChange)="onTerritoriesClosed($event)">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="territorySearch" [ngModelOptions]="{ standalone: true }"
                placeholderLabel="Buscar territorio..." noEntriesFoundLabel="No se encontraron resultados"
                (ngModelChange)="filterTerritoryOptions()">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let t of filteredTerritoryOptions" [value]="t.id">
              <!-- El código solo si el nombre no lo trae ya: nada de datos repetidos. -->
              <span *ngIf="t.externalKeys?.code && !(t.name || '').includes(t.externalKeys.code)"
                class="font-semibold">{{ t.externalKeys.code }} — </span>{{ t.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="mt-1 flex flex-wrap items-center gap-2">
          <button mat-stroked-button type="button" (click)="toggleAllTerritories()">
            {{ allTerritoriesSelected ? 'Quitar todos' : 'Seleccionar todos' }}
          </button>
          <span class="text-secondary text-xs">
            {{ selectedTerritoryIds.length }} de {{ territoryOptions.length }} seleccionados. Todos = sin filtro.
          </span>
        </div>
      </div>

      <!-- Camiones ASIGNADOS en el maestro a las rutas de entrega del alcance: los
           que el negocio dice que salen, no el catálogo de vehículos de la compañía.
           Excluir uno (taller, préstamo) hace que sus rutas se planifiquen con la
           capacidad de respaldo Y quede declarado — antes el plan usaba la
           capacidad de un camión que no iba a salir del patio. -->
      <div class="flex flex-col">
        <mat-form-field appearance="fill" class="w-full" subscriptSizing="dynamic">
          <mat-label>Camiones asignados</mat-label>
          <mat-select [(ngModel)]="selectedVehicleIds" multiple>
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="vehicleSearch" [ngModelOptions]="{ standalone: true }"
                placeholderLabel="Buscar camión..." noEntriesFoundLabel="No se encontraron resultados"
                (ngModelChange)="filterVehicleOptions()">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let v of filteredVehicles" [value]="'' + v._id">
              {{ v.name }}
              <span *ngIf="vehicleDetailLabel(v)" class="text-secondary text-xs"> · {{ vehicleDetailLabel(v) }}</span>
              <!-- Varias rutas se lo disputan: informativo, no bloqueante. El
                   optimizador lo asigna al territorio con más pedidos y lo declara
                   en el resultado. Se nombran las RUTAS, que es lo que el operador
                   reconoce y edita en el maestro. -->
              <span *ngIf="isDuplicateVehicle(v)" class="text-xs font-semibold text-amber-700">
                · en {{ duplicateRoutesLabel(v) }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span *ngIf="vehicles.length" class="text-secondary mt-1 text-xs">
          {{ selectedVehicleIds.length }} de {{ vehicles.length }} asignados. Las rutas de un
          camión excluido se planifican con la capacidad por defecto.
        </span>
        <span *ngIf="!vehicles.length" class="text-secondary mt-1 text-xs">
          Ninguna ruta de entrega del alcance elegido tiene camión asignado en
          master/routing/sub-route: se planifica con la capacidad por defecto.
        </span>
      </div>

      <!-- Atención por parada: el supuesto más determinante del plan. Opciones
           acotadas a propósito: un campo libre invitaría a bajarla hasta que
           "entre todo" y producir un plan irrealizable. Se aplica al generar. -->
      <mat-form-field appearance="fill" class="w-full self-start" subscriptSizing="dynamic">
        <mat-label>Atención por parada</mat-label>
        <mat-select [(ngModel)]="selectedServiceMin">
          <mat-option *ngFor="let m of serviceMinOptions" [value]="m">{{ m }} min por parada</mat-option>
        </mat-select>
        <mat-hint class="text-xs">Cuanto más alta, menos clientes entran en la jornada.</mat-hint>
      </mat-form-field>

      <!-- Franja de entrega: la otra mitad de la ecuación del tiempo. El maestro
           no la tiene (su `itinerary` es un rango de vigencia, no una jornada). -->
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs font-medium">Franja de entrega</span>
        <div class="flex items-center gap-2">
          <input type="time" [(ngModel)]="shiftStart" aria-label="Inicio de la franja de entrega"
            class="h-10 min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800" />
          <span class="text-secondary shrink-0 text-xs">a</span>
          <input type="time" [(ngModel)]="shiftEnd" aria-label="Fin de la franja de entrega"
            class="h-10 min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800" />
        </div>
        <span class="text-secondary text-xs">
          Tiempo total del día por ruta. Inválida o menor a 2 h cae a 08:00–17:00.
        </span>
      </div>

      <!-- ACA VIVIA el control de viajes por camion, con su campo de minutos de
           recarga. Se retiro, y para devolverlo hace falta que el multi-viaje TENGA
           EFECTO: solo se aplica donde el maestro de la sub-ruta declara
           `allowMultiTrips`, y ninguna pantalla de la app escribe esa bandera. El
           control se podia mover y el plan salia identico — una palanca falsa en el
           unico panel donde todo lo demas si cambia el plan, y peor: mandaba a buscar
           la causa de un camion a medio llenar donde no estaba.
           La fontaneria queda (`maxTrips`/`reloadMin` fijos en 1 y 30, y el camino al
           request intacto), asi que devolver el control es volver a poner estos dos
           campos. Ver el cambio `hide-reload-control`. -->

      <!-- Combustible. Los UNICOS controles de este panel que NO cambian el plan:
           todos los demas son entradas del optimizador, asi que moverlos deja viejo
           el plan que se esta mirando (de ahi `assumedServiceMin` / `assumedShift`).
           Estos dos solo alimentan la traduccion de km ahorrados a lempiras, asi que
           cambiarlos recalcula el numero al instante, sin re-correr. Por eso van en
           su propio bloque rotulado: en un panel donde todo lo demas significa "hay
           que volver a generar", si no se separan se leen igual.

           El precio se carga a MANO y no se trae de ninguna API: estimarlo del crudo
           da entre -8,9 % y -21,1 % contra el precio real de la SEN (el diesel, que
           es el de esta flota, es el peor), y el precio local no sigue al crudo -
           entre abril y agosto de 2026 el WTI cayo 12,8 % y la Super se movio 8
           centavos. Ademas no hay fuente estructurada gratis: la SEN publica
           imagenes JPG. Lo que faltaba no era calcular el precio: era tenerlo a
           mano, y eso lo resuelve el boton. -->
      <div class="flex flex-col gap-2 rounded-xl border border-slate-200 bg-slate-50/60 p-3">
        <div class="flex flex-wrap items-baseline justify-between gap-2">
          <span class="text-sm font-semibold text-slate-800">Combustible</span>
          <span class="text-secondary text-[11px]">No cambia el plan</span>
        </div>
        <div class="flex flex-wrap gap-3">
          <mat-form-field appearance="fill" class="min-w-0 flex-1" subscriptSizing="dynamic">
            <mat-label>Precio por galón (L)</mat-label>
            <input matInput type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="fuelPricePerGallon"
              placeholder="134.25" />
          </mat-form-field>
          <mat-form-field appearance="fill" class="min-w-0 flex-1" subscriptSizing="dynamic">
            <mat-label>Rendimiento (km por galón)</mat-label>
            <!-- Arranca con un valor de referencia, no vacio: el operador tipico no sabe
                 el rendimiento de memoria, y un campo vacio deja el ahorro en lempiras
                 apagado hasta que alguien lo averigue. El aviso de abajo declara que es
                 referencia y no una medicion de esta flota. -->
            <input matInput type="number" min="0" step="0.1" inputmode="decimal" [(ngModel)]="kmPerGallon"
              placeholder="10" />
          </mat-form-field>
        </div>

        <!-- El precio SI va a un enlace: cambia cada semana y la SEN es la autoridad.
             El rendimiento NO: la tabla vive en la pantalla. Un enlace sacaba al usuario
             del dialogo, dependia de un sitio ajeno, y las fuentes de consumo de camiones
             suelen publicar en km por LITRO cuando el campo pide km por GALON — habia que
             cargar la conversion al lado para evitar un error de 3,785x hacia arriba. -->
        <a [href]="fuelPriceSourceUrl" target="_blank" rel="noopener noreferrer"
          class="flex w-fit items-center gap-1.5 text-xs font-semibold text-indigo-600 hover:underline">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:arrow-top-right-on-square"></mat-icon>
          Ver precios oficiales (SEN)
        </a>

        <div class="flex flex-col gap-1">
          <button type="button"
            class="flex w-fit items-center gap-1.5 text-xs font-semibold text-indigo-600 hover:underline"
            [attr.aria-expanded]="fuelReferenceOpen"
            (click)="fuelReferenceOpen = !fuelReferenceOpen">
            <mat-icon class="icon-size-4 transition-transform" [class.rotate-180]="fuelReferenceOpen"
              svgIcon="heroicons_outline:chevron-down"></mat-icon>
            Consumos de referencia
          </button>
          <div *ngIf="fuelReferenceOpen"
            class="flex flex-col gap-2 rounded-lg border border-slate-200 bg-white p-3">
            <span class="text-secondary text-xs">
              Camiones diésel de reparto, en <b>km por galón</b> — la misma unidad del campo.
              Si no se sabe el tipo de ruta, el valor a usar es el del
              <b>promedio esperado</b>.
            </span>
            <div class="overflow-x-auto">
              <table class="w-full text-xs tabular-nums">
                <thead>
                  <tr class="border-b border-slate-300 text-slate-500">
                    <th class="py-1 pr-3 text-left font-semibold">Modelo</th>
                    <th class="px-2 py-1 text-left font-semibold">Peso bruto</th>
                    <th class="px-2 py-1 text-right font-semibold">Montañosa / cargado</th>
                    <th class="px-2 py-1 text-right font-semibold">Plana / ligero</th>
                    <th class="py-1 pl-2 text-right font-semibold">Promedio esperado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of fuelYieldReference" class="border-b border-slate-100">
                    <td class="py-1 pr-3 font-medium text-slate-800">{{ r.model }}</td>
                    <td class="text-secondary px-2 py-1">{{ r.weight }}</td>
                    <td class="px-2 py-1 text-right">{{ r.loaded }}</td>
                    <td class="px-2 py-1 text-right">{{ r.light }}</td>
                    <td class="py-1 pl-2 text-right font-bold text-slate-900">{{ r.expected }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <span class="text-secondary text-[11px]">
              Son valores de referencia por modelo, no de esta flota: el consumo real depende
              de la carga, el terreno y el mantenimiento.
            </span>
          </div>
        </div>

        <span class="text-secondary text-xs">
          Los valores de arranque son una referencia, no una medición de esta flota:
          conviene reemplazarlos. Sin ellos, el ahorro se informa solo en tiempo y
          kilómetros.
        </span>
      </div>

      <!-- Qué conjuntos entran. Ambos se acotan por la fecha de CARGA del selector
           de la pantalla, igual que las pestañas. -->
      <div class="flex flex-col gap-1">
        <span class="text-sm font-semibold text-slate-800">
          Pedidos a optimizar · {{ data.loadDate | date: 'dd/MM/yyyy' }}
        </span>
        <mat-radio-group [(ngModel)]="scopeSelection" class="flex flex-col gap-0.5">
          <mat-radio-button *ngFor="let opt of scopeOptions" [value]="opt.value">
            {{ opt.label }}
            <span class="text-secondary text-xs">({{ opt.hint }})</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Las descartadas se listan: si falta la que el usuario busca, tiene que
         poder ver por qué no está. -->
    <div *ngIf="!officesError && officesWithoutGeo.length"
      class="flex items-start gap-3 rounded-2xl border border-amber-100 bg-amber-50 p-4 text-xs text-amber-900">
      <mat-icon class="icon-size-5 shrink-0 text-amber-500" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
      <div>
        <div class="font-semibold">Estas oficinas no se pueden optimizar (sin geolocalización):</div>
        <div>{{ officesWithoutGeo.join(', ') }}</div>
      </div>
    </div>

    <!-- Fallo de RED, no de datos: decir "no hay oficinas" cuando la consulta se
         cayo es afirmar algo sobre el maestro que no se sabe. -->
    <div *ngIf="!officesLoading && officesError"
      class="flex flex-col gap-3 rounded-2xl border border-rose-100 bg-rose-50 p-4">
      <div class="flex items-start gap-3">
        <mat-icon class="text-rose-500 icon-size-5 shrink-0"
          svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
        <div class="flex flex-col gap-1">
          <span class="text-sm font-semibold text-rose-700">
            No se pudieron traer las oficinas de ventas.
          </span>
          <span class="text-xs text-rose-800">{{ officesError }}</span>
        </div>
      </div>
      <button mat-stroked-button color="warn" type="button" class="self-start" (click)="loadOfficeOptions()">
        <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
        Reintentar
      </button>
    </div>

    <div *ngIf="!officesLoading && !officesError && !officeOptions.length"
      class="flex items-center gap-3 rounded-2xl border border-amber-100 bg-amber-50 p-4">
      <mat-icon class="text-amber-500 icon-size-5" svgIcon="heroicons_outline:inbox"></mat-icon>
      <span class="text-sm font-medium text-amber-700">
        <!-- Dos problemas con dos dueños distintos: o el maestro no tiene
             oficinas activas, o las tiene y ninguna esta geolocalizada. -->
        <ng-container *ngIf="officesLoadedCount">
          Las {{ officesLoadedCount }} oficinas activas no tienen geolocalización usable: sin
          coordenadas no hay almacén del que salir, así que no hay plan posible.
        </ng-container>
        <ng-container *ngIf="!officesLoadedCount">
          El maestro no devolvió ninguna oficina de ventas activa.
        </ng-container>
      </span>
    </div>
  </div>

  <!-- Cargando / optimizando -->
  <div *ngIf="state === 'loading' || state === 'optimizing'"
    class="flex flex-col items-center justify-center gap-3 py-14">
    <app-route-loading-animation class="h-40 w-40"></app-route-loading-animation>
    <div class="text-base font-semibold text-slate-900">{{ progressLabel }}</div>
    <div class="text-secondary max-w-md text-center text-sm">
      Cada ruta se planifica con el camión, la jornada y las ventanas que declara su maestro.
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="state === 'error'"
    class="flex flex-col items-center justify-center gap-3 rounded-2xl border border-rose-100 bg-rose-50 py-12">
    <mat-icon class="text-rose-500" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
    <div class="font-semibold text-rose-700">{{ errorMessage }}</div>
    <button mat-stroked-button color="warn" (click)="run()">Reintentar</button>
  </div>

  <!-- Sin pedidos en el alcance -->
  <div *ngIf="state === 'empty'"
    class="flex flex-col items-center justify-center gap-2 rounded-2xl border border-amber-100 bg-amber-50 py-14">
    <div class="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100">
      <mat-icon class="text-amber-500" svgIcon="heroicons_outline:inbox"></mat-icon>
    </div>
    <div class="text-base font-semibold text-slate-900">Sin pedidos para optimizar</div>
    <div class="text-secondary max-w-md text-center text-sm">
      No hay pedidos de entrega (DT003) —ni con viaje ni sin viaje— para las oficinas elegidas
      <ng-container *ngIf="loadedScopeLabel">({{ loadedScopeLabel }})</ng-container>
      en el día y los filtros vigentes. Prueba con otras oficinas, incluye todo el pendiente sin
      asignar, o ajusta los filtros de la pantalla.
    </div>
  </div>

  <!-- Resultado -->
  <ng-container *ngIf="state === 'result' && dash">
    <!-- Gestor de confirmación: la última palabra sobre el ORDEN antes de
         persistir. Reemplaza el contenido (no un diálogo anidado: ya peleamos
         una vez con `disableClose` + Escape; anidar duplica ese problema). -->
    <ng-container *ngIf="reviewOpen">
      <!-- cdkDropListGroup conecta las listas de todas las rutas: cruzar es
           posible, y el predicado de entrada decide HACIA cuáles. -->
      <div class="flex flex-col gap-4" cdkDropListGroup>
        <div class="flex flex-wrap items-center gap-3">
          <div class="flex w-fit rounded-lg border border-slate-200 bg-white p-0.5">
            <button type="button" class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium"
              [class.bg-indigo-500]="reviewTab === 'optimizer'" [class.text-white]="reviewTab === 'optimizer'"
              (click)="reviewTab = 'optimizer'">
              <mat-icon class="icon-size-4" svgIcon="heroicons_outline:sparkles"></mat-icon> Del optimizador
            </button>
            <button type="button" class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium"
              [class.bg-indigo-500]="reviewTab === 'custom'" [class.text-white]="reviewTab === 'custom'"
              (click)="reviewTab = 'custom'">
              <mat-icon class="icon-size-4" svgIcon="heroicons_outline:bars-3"></mat-icon> Personalizado
            </button>
          </div>
          <span class="text-secondary text-xs">
            {{ reviewRoutes.length }} rutas por confirmar
            <ng-container *ngIf="reviewCustomCount"> · {{ reviewCustomCount }} con orden personalizado</ng-container>
          </span>

          <!-- El MISMO selector que el resultado, y el mismo `viewMode`: una sola
             preferencia de presentación para toda la pantalla. Hasta ahora el gestor
             honraba el modo pero no lo ofrecía —el control vive en la vista de
             resultado, que con el gestor abierto no está—, así que entrar acá
             congelaba el modo con el que se venía. Rige las rutas Y el pool. -->
          <div class="ml-auto flex w-fit shrink-0 rounded-lg border border-slate-200 bg-white p-0.5">
            <button type="button" class="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium"
              [class.bg-slate-900]="viewMode === 'list'" [class.text-white]="viewMode === 'list'"
              [attr.aria-pressed]="viewMode === 'list'" (click)="viewMode = 'list'">
              <mat-icon class="icon-size-4" svgIcon="heroicons_outline:bars-3"></mat-icon> Tarjetas
            </button>
            <button type="button" class="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium"
              [class.bg-slate-900]="viewMode === 'grid'" [class.text-white]="viewMode === 'grid'"
              [attr.aria-pressed]="viewMode === 'grid'" (click)="viewMode = 'grid'">
              <mat-icon class="icon-size-4" svgIcon="heroicons_outline:squares-2x2"></mat-icon> Grid
            </button>
          </div>
        </div>

        <!-- Los pedidos que no entraron al plan y SÍ se pueden entregar.
             Colapsado de entrada, como el resto de los bloques de esta pantalla.
             Solo en la pestaña editable: la del optimizador es la vara contra la que se
             mide si un orden es personalizado, y escribir ahí la destruiría. -->
        <div *ngIf="reviewTab === 'custom' && pendingCount"
          class="overflow-hidden rounded-2xl border border-amber-200 bg-white">
          <div class="flex cursor-pointer flex-wrap items-center justify-between gap-2 bg-amber-50 p-3"
            role="button" tabindex="0" [attr.aria-expanded]="pendingOpen"
            (click)="pendingOpen = !pendingOpen" (keydown.enter)="pendingOpen = !pendingOpen">
            <span class="flex min-w-0 items-center gap-2">
              <mat-icon class="icon-size-5 shrink-0 text-amber-500"
                svgIcon="heroicons_outline:inbox-arrow-down"></mat-icon>
              <span class="text-sm font-bold text-amber-900">
                {{ pendingCount }} {{ pendingCount === 1 ? 'pedido' : 'pedidos' }} sin asignar
              </span>
              <span class="text-[11px] text-amber-800">
                solo se pueden añadir a rutas que visiten el territorio del cliente
              </span>
            </span>
            <mat-icon class="icon-size-5 text-amber-400 transition-transform" [class.rotate-180]="pendingOpen"
              svgIcon="heroicons_outline:chevron-down"></mat-icon>
          </div>

          <!-- UNA sola lista para todos los motivos: es el ORIGEN del arrastre, y una
               por grupo multiplicaría los `cdkDropList` sin que el destino cambie. El
               motivo va como encabezado de sección dentro de ella. -->
          <div *ngIf="pendingOpen" class="flex flex-col gap-3 p-3" cdkDropList
            [cdkDropListData]="PENDING_LIST" [cdkDropListEnterPredicate]="pendingEnterPredicate"
            [cdkDropListSortingDisabled]="true">
            <div *ngFor="let g of pendingGroupsView()" class="flex flex-col gap-1.5">
              <!-- El motivo dice si añadirlo es razonable o si lo correcto es arreglar
                   el dato en el maestro. Por eso encabeza el grupo y no se esconde. -->
              <span class="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                {{ g.reason }} · {{ g.items.length }}
              </span>

              <!-- MOSAICO. El pool sigue el MISMO `viewMode` que las rutas: es una sola
                   preferencia de presentación, como ya lo son el resultado y el gestor.
                   Dos preferencias obligarían a elegir dos veces lo mismo, y a
                   persistir un segundo campo en la foto de la corrida.
                   `auto-fill` y no puntos de corte de ventana: las columnas se cuentan
                   solas, igual que en los mosaicos que ya existen. La ficha es más
                   ancha que un tile de ruta porque acá lo que identifica es el nombre
                   del cliente y su dirección, no un rótulo corto. -->
              <div *ngIf="viewMode === 'grid'"
                class="grid content-start gap-2 grid-cols-[repeat(auto-fill,minmax(15rem,1fr))]">
                <div *ngFor="let item of g.items" cdkDrag [cdkDragData]="item"
                  [cdkDragDisabled]="!pendingTargets(item).length"
                  class="flex flex-col gap-2 rounded-xl border border-slate-100 bg-white p-3 shadow-sm transition-shadow hover:shadow-md"
                  [class.opacity-60]="!pendingTargets(item).length">
                  <!-- La ficha ENTERA es el asa, menos los controles: en un mosaico no
                       hay dónde poner un asa aparte sin comerse el ancho útil. -->
                  <div cdkDragHandle class="flex min-w-0 flex-col gap-0.5"
                    [class.cursor-grab]="pendingTargets(item).length"
                    (pointerdown)="beginPendingDrag(item)">
                    <div class="truncate text-sm font-medium text-slate-800" [title]="item.point.name">
                      {{ item.point.name }}
                    </div>
                    <div class="text-secondary line-clamp-2 text-xs" [title]="item.point.address">
                      {{ item.point.address }}
                    </div>
                    <span class="text-[11px] text-slate-400">
                      {{ item.point.weightLb | number: '1.0-1' }} lb
                    </span>
                  </div>
                  <div class="flex items-center justify-end">
                    <ng-container
                      *ngTemplateOutlet="pendingActions; context: { $implicit: item }"></ng-container>
                  </div>
                </div>
              </div>

              <!-- LISTA. La misma ficha en una fila, para cuando lo que importa es
                   recorrer muchos pedidos de un vistazo vertical. -->
              <ng-container *ngIf="viewMode === 'list'">
                <div *ngFor="let item of g.items" cdkDrag [cdkDragData]="item"
                  [cdkDragDisabled]="!pendingTargets(item).length"
                  class="flex items-center gap-3 rounded-md bg-white px-2 py-1 ring-1 ring-slate-100"
                  [class.opacity-60]="!pendingTargets(item).length">
                  <div cdkDragHandle class="flex min-w-0 flex-1 items-center gap-3"
                    [class.cursor-grab]="pendingTargets(item).length"
                    (pointerdown)="beginPendingDrag(item)">
                    <mat-icon class="icon-size-4 shrink-0 text-slate-300"
                      svgIcon="heroicons_outline:bars-3"></mat-icon>
                    <div class="min-w-0 flex-1">
                      <div class="truncate text-sm font-medium text-slate-800">{{ item.point.name }}</div>
                      <div class="text-secondary truncate text-xs">{{ item.point.address }}</div>
                    </div>
                    <span class="text-xs text-slate-400">{{ item.point.weightLb | number: '1.0-1' }} lb</span>
                  </div>
                  <ng-container
                    *ngTemplateOutlet="pendingActions; context: { $implicit: item }"></ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-container *ngIf="viewMode === 'list'">
          <div *ngFor="let r of reviewRoutes"
            class="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm"
            [class.hidden]="reviewRouteHidden(r)" [class.ring-2]="reviewRouteIsTarget(r)"
            [class.ring-indigo-300]="reviewRouteIsTarget(r)">
            <!-- Colapsable y CERRADA por defecto, como las tarjetas del resultado:
               17 rutas × ~14 filas arrastrables de entrada entierran el panorama. -->
            <div class="flex cursor-pointer flex-wrap items-center justify-between gap-2 border-l-4 p-3"
              [style.border-left-color]="r.color" role="button" tabindex="0" [attr.aria-expanded]="r.open"
              (click)="toggleReviewRoute(r)" (keydown.enter)="toggleReviewRoute(r)">
              <!-- `flex-wrap` y `min-w-0`: la tarjeta es `overflow-hidden`, asi que una
                 fila que no envuelve RECORTA lo que se desborda. Con las insignias de
                 tiempo agregadas, las ultimas quedaban fuera de la vista sin ninguna
                 senal — y un assert de texto no lo detecta, porque el nodo existe. -->
              <div class="flex min-w-0 flex-wrap items-center gap-2">
                <span class="h-3 w-3 rounded-full" [style.background-color]="r.color"></span>
                <span class="flex min-w-0 flex-col">
                  <span class="text-sm font-bold text-slate-900">{{ r.label }}</span>
                  <span *ngIf="r.territoryName" class="text-[10px] text-slate-500">
                    Territorio {{ r.territoryName }}
                  </span>
                </span>
                <span class="text-secondary text-xs">{{ r.stops.length }} paradas</span>
                <!-- Carga VIGENTE vs el techo del día del camión, recalculada con
                   cada movimiento entre rutas — la única métrica del gestor que
                   sí se actualiza en vivo. -->
                <span *ngIf="reviewDayCapacityLb(r) > 0" class="rounded-full px-2 py-0.5 text-[10px] font-bold"
                  [ngClass]="reviewOverloadLb(r) > 0 ? 'bg-rose-50 text-rose-600' : 'bg-slate-100 text-slate-500'"
                  [title]="reviewOverloadLb(r) > 0
                  ? ('Supera por ' + (reviewOverloadLb(r) | number: '1.0-0') + ' lb lo que este camión carga en el día (capacidad × viajes): mover pedidos a otra ruta o dejarlos donde estaban.')
                  : 'Carga vigente vs lo que este camión carga en el día (capacidad × viajes). Se recalcula al mover pedidos entre rutas.'">
                  <ng-container *ngIf="reviewOverloadLb(r) > 0">⚠ </ng-container>{{ reviewLoadLb(r) | number: '1.0-0' }}
                  / {{ reviewDayCapacityLb(r) | number: '1.0-0' }} lb<ng-container *ngIf="r.trips > 1"> · {{ r.trips }}
                    viajes</ng-container>
                </span>
                <span *ngIf="r.custom"
                  class="rounded-full bg-violet-50 px-2 py-0.5 text-[10px] font-bold text-violet-600">
                  orden personalizado
                </span>
                <ng-container
                  *ngTemplateOutlet="routeTimeBadges; context: { $implicit: r }"></ng-container>
              </div>
              <div class="flex items-center gap-2">
                <ng-container
                  *ngTemplateOutlet="routeRecalcActions; context: { $implicit: r }"></ng-container>
                <!-- Ver esta ruta en el mapa. `stopPropagation` por lo mismo que
                   Restaurar: el encabezado entero colapsa la tarjeta.
                   En la pestana personalizada las paradas del mapa las pone el GESTOR
                   y no se dibuja trayecto; en la del optimizador el mapa del plan ya es
                   cierto. Lo decide `openReviewRouteOnMap`. -->
                <button *ngIf="truckIdOfReviewRoute(r)" mat-icon-button type="button"
                  (click)="$event.stopPropagation(); openReviewRouteOnMap(r)"
                  title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                  <mat-icon class="icon-size-5" svgIcon="heroicons_outline:map"></mat-icon>
                </button>
                <!-- stopPropagation: restaurar no debe colapsar la tarjeta. -->
                <button *ngIf="r.custom && reviewTab === 'custom'" mat-stroked-button type="button"
                  (click)="$event.stopPropagation(); resetReview(r)">
                  <mat-icon svgIcon="heroicons_outline:arrow-uturn-left"></mat-icon>
                  Deshacer cambios
                </button>
                <mat-icon class="icon-size-5 text-slate-400 transition-transform" [class.rotate-180]="r.open"
                  svgIcon="heroicons_outline:chevron-down"></mat-icon>
              </div>
            </div>

            <!-- Del optimizador: solo lectura. Si hay orden personalizado, acá se
               VE el del motor pero se CONFIRMA el personalizado — decirlo evita
               creer que cambiar de pestaña lo perdió. -->
            <ng-container *ngIf="reviewTab === 'optimizer' && r.open">
              <ng-container *ngTemplateOutlet="reviewOptimizerBody; context: { $implicit: r, tl: reviewTimelineOf(r) }"></ng-container>
            </ng-container>

            <!-- Personalizado: arrastrar reordena dentro de la ruta Y mueve entre
               rutas — al levantar una ficha, las rutas que NO visitan los
               territorios del cliente se ocultan y solo quedan los destinos
               válidos (reaparecen al soltar). Los ↑/↓ reordenan por teclado. -->
            <ng-container *ngIf="reviewTab === 'custom' && r.open">
              <ng-container *ngTemplateOutlet="reviewCustomBody; context: { $implicit: r, tl: reviewTimelineOf(r) }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

        <!-- MODO GRID del gestor: mosaico de rutas a la izquierda, las paradas de la
           seleccionada a la derecha. Reusa `--grid-tiles-w`, el `auto-fill` y el
           divisor del resultado: es la misma preferencia de presentacion.
           El tile es ADEMAS destino del arrastre. El mosaico muestra las paradas de
           una sola ruta, asi que el cruce entre rutas no tendria donde ocurrir; con
           el tile como destino, los dos gestos se distinguen por donde cae el pedido
           —panel = reordenar, tile = mover— y no hace falta un control que lo diga. -->
        <div *ngIf="viewMode === 'grid'" [style.--grid-tiles-w]="gridTilesWidthCss"
          class="grid gap-4 lg:grid-cols-[var(--grid-tiles-w,22rem)_auto_minmax(0,1fr)]">

          <div class="grid content-start gap-2 grid-cols-[repeat(auto-fill,minmax(10rem,1fr))]">
            <!-- Cada tile es un `cdkDropList` con el MISMO predicado de las tarjetas:
               `reviewEnterPredicate` opera sobre `subRouteId` y no le importa si el
               destino es una tarjeta grande o un tile, asi que las reglas de que se
               puede mover a donde no se tocan.
               Deshabilitado en la pestana del optimizador: ahi es solo lectura. -->
            <div *ngFor="let r of visibleReviewRoutes()" cdkDropList [cdkDropListData]="r"
              [cdkDropListDisabled]="reviewTab !== 'custom'" [cdkDropListEnterPredicate]="reviewEnterPredicate"
              (cdkDropListDropped)="onReviewDrop(r, $event)"
              class="relative rounded-xl border border-slate-100 border-l-4 bg-white shadow-sm transition-shadow hover:shadow-md"
              [style.border-left-color]="r.color" [class.ring-2]="reviewRouteIsTarget(r) || isReviewRouteSelected(r)"
              [class.ring-emerald-400]="reviewRouteIsTarget(r)"
              [class.ring-indigo-400]="!reviewRouteIsTarget(r) && isReviewRouteSelected(r)">
              <!-- El icono del mapa, en la esquina y FUERA del boton de seleccionar:
                 un boton dentro de otro no es html valido. Con la capa superpuesta no
                 cambia la ruta seleccionada del mosaico ni saca al usuario de aca. -->
              <button *ngIf="truckIdOfReviewRoute(r)" mat-icon-button type="button"
                class="!absolute right-0 top-0 z-10" (click)="openReviewRouteOnMap(r)"
                title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:map"></mat-icon>
              </button>
              <button type="button" class="flex w-full flex-col gap-1.5 p-3 pr-9 text-left" (click)="selectReviewRoute(r)"
                [attr.aria-pressed]="isReviewRouteSelected(r)" [title]="r.label + ' · ' + r.stops.length + ' paradas'">
                <span class="truncate text-xs font-bold text-slate-900">{{ r.label }}</span>
                <span *ngIf="r.territoryName"
                  class="w-fit truncate rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
                  Territorio {{ r.territoryName }}
                </span>
                <!-- La ocupacion, EN VIVO. Se recalcula al mover pedidos: es la unica
                   metrica del gestor que lo hace, y por eso el tile se pone en rojo
                   al sobrecargarlo, antes de confirmar. Se omite sin capacidad de
                   dia conocida en vez de mostrar un cero enganoso. -->
                <ng-container *ngIf="reviewDayCapacityLb(r) > 0">
                  <div class="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
                    <div class="h-full rounded-full transition-all" [style.width.%]="reviewLoadPct(r)"
                      [style.background-color]="reviewOverloadLb(r) > 0 ? '#f43f5e' : r.color"></div>
                  </div>
                  <span class="flex items-baseline justify-between gap-2 text-[11px] text-slate-500">
                    <span>{{ r.stops.length }} paradas</span>
                    <span class="font-semibold" [class.text-rose-600]="reviewOverloadLb(r) > 0"
                      [class.text-slate-700]="reviewOverloadLb(r) === 0" [title]="reviewOverloadLb(r) > 0
                      ? ('Supera por ' + (reviewOverloadLb(r) | number: '1.0-0') + ' lb lo que este camión carga en el día.')
                      : 'Carga vigente vs lo que este camión carga en el día.'">
                      <ng-container *ngIf="reviewOverloadLb(r) > 0">⚠ </ng-container>{{ reviewLoadLb(r) | number: '1.0-0' }}
                      lb · {{ reviewLoadPct(r) }}%
                    </span>
                  </span>
                </ng-container>
                <!-- La ventana del dia tambien en el mosaico. El tile no recibe el
                   timeline por contexto —el cuerpo si— asi que lo resuelve el mismo:
                   una llamada por tile y por ciclo, que es barata y siempre esta al
                   dia. Memoizarla exigiria invalidarla en las siete mutaciones que
                   cambian una ruta, para un numero que existe para no atrasarse. -->
                <span class="text-[11px] text-slate-500">
                  <ng-container
                    *ngTemplateOutlet="routeWindow; context: { $implicit: reviewTimelineOf(r), compact: true }"></ng-container>
                </span>
                <span *ngIf="reviewDayCapacityLb(r) <= 0" class="text-[11px] text-slate-500">
                  {{ r.stops.length }} paradas
                </span>
                <!-- El badge contextual de ESTE paso. En el resultado son las
                   coincidencias del filtro; aca es que rutas tocaste, que es lo que
                   decide que revisar antes de persistir. -->
                <span *ngIf="r.custom"
                  class="w-fit rounded-full bg-violet-50 px-2 py-0.5 text-[10px] font-bold text-violet-600">
                  orden personalizado
                </span>
              </button>
            </div>

            <div *ngIf="!visibleReviewRoutes().length"
              class="rounded-xl border border-dashed border-slate-200 p-4 text-xs text-slate-500">
              No hay rutas que puedan recibir este pedido.
            </div>
          </div>

          <!-- El divisor, el mismo del resultado: comparte `--grid-tiles-w`. -->
          <div class="hidden lg:flex lg:items-center lg:justify-center" role="separator" aria-orientation="vertical"
            tabindex="0" aria-label="Ancho del mosaico de rutas" [attr.aria-valuenow]="tilesWidthAria"
            [attr.aria-valuemin]="tilesWidthMin" title="Arrastrar para cambiar el ancho · flechas para ajustar"
            (pointerdown)="startTilesResize($event)" (keydown.ArrowLeft)="nudgeTilesWidth($event, -16)"
            (keydown.ArrowRight)="nudgeTilesWidth($event, 16)">
            <div class="group flex h-full w-3 cursor-col-resize touch-none items-center justify-center">
              <span class="h-16 w-1 rounded-full bg-slate-200 transition-colors group-hover:bg-indigo-400"></span>
            </div>
          </div>

          <!-- El panel. `selectedReviewRouteOf` DERIVA cual: una elegida que el
             arrastre escondio dejaria el panel mostrando una ruta que no esta en el
             mosaico. Sin `r.open`: se construye UNA ruta de diecisiete. -->
          <div *ngIf="selectedReviewRouteOf() as r"
            class="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
            <div class="flex flex-col gap-1.5 border-l-4 p-4" [style.border-left-color]="r.color">
              <div class="flex flex-wrap items-center gap-2">
                <span class="h-3 w-3 shrink-0 rounded-full" [style.background-color]="r.color"></span>
                <span class="text-sm font-bold text-slate-900">{{ r.label }}</span>
                <span *ngIf="r.custom"
                  class="rounded-full bg-violet-50 px-2 py-0.5 text-[10px] font-bold text-violet-600">
                  orden personalizado
                </span>
                <!-- El mapa de la ruta que el panel esta mostrando. El tile no lo
                   lleva: su contenido ya es un boton (seleccionar) y es la zona de
                   soltar del arrastre. Las acciones de la ruta viven aca. -->
                <button *ngIf="truckIdOfReviewRoute(r)" mat-icon-button type="button" class="ml-auto"
                  (click)="openReviewRouteOnMap(r)"
                  title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                  <mat-icon class="icon-size-5" svgIcon="heroicons_outline:map"></mat-icon>
                </button>
                <!-- Las acciones de la ruta ya NO viven aca: en mosaico estan en la barra
                   fija, rotuladas con el nombre de la ruta seleccionada, que es la que
                   este panel muestra. Repetirlas seria dos lugares para una accion sobre
                   el mismo objeto. El boton del mapa se queda: no es destructivo y
                   acompaña a la ruta que se esta mirando. -->
              </div>
              <div class="text-secondary flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
                <span *ngIf="r.territoryName"
                  class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
                  Territorio {{ r.territoryName }}
                </span>
                <span>{{ r.stops.length }} paradas</span>
                <span *ngIf="reviewDayCapacityLb(r) > 0" class="rounded-full px-2 py-0.5 text-[10px] font-bold"
                  [ngClass]="reviewOverloadLb(r) > 0 ? 'bg-rose-50 text-rose-600' : 'bg-slate-100 text-slate-500'">
                  <ng-container *ngIf="reviewOverloadLb(r) > 0">⚠ </ng-container>{{ reviewLoadLb(r) | number: '1.0-0' }}
                  / {{ reviewDayCapacityLb(r) | number: '1.0-0' }} lb<ng-container *ngIf="r.trips > 1"> · {{ r.trips }}
                    viajes</ng-container>
                </span>
                <ng-container
                  *ngTemplateOutlet="routeTimeBadges; context: { $implicit: r }"></ng-container>
              </div>
            </div>

            <ng-container *ngIf="reviewTab === 'optimizer'">
              <ng-container *ngTemplateOutlet="reviewOptimizerBody; context: { $implicit: r, tl: reviewTimelineOf(r) }"></ng-container>
            </ng-container>
            <ng-container *ngIf="reviewTab === 'custom'">
              <ng-container *ngTemplateOutlet="reviewCustomBody; context: { $implicit: r, tl: reviewTimelineOf(r) }"></ng-container>
            </ng-container>
          </div>
        </div>

        <!-- Los cuerpos de paradas, UNA sola vez cada uno: los renderizan el modo
           tarjetas y el modo grid. Dos copias del cuerpo arrastrable divergen a la
           primera correccion, y esta es la ultima palabra sobre el orden antes de
           persistir: aca una divergencia silenciosa se paga caro.

           Van DENTRO del `cdkDropListGroup` A PROPOSITO: el inyector de una vista
           embebida es el del lugar donde el template se DECLARA, no donde se
           inserta. Declarados afuera, el `cdkDropList` del cuerpo no encontraria el
           grupo y el cruce entre rutas se romperia EN SILENCIO. -->
        <!-- `tl` llega por contexto: se resuelve UNA vez por ruta. Llamarlo por fila
             reconstruiría el mapa de tiempos en cada parada. -->
        <ng-template #reviewOptimizerBody let-r let-tl="tl">
          <div class="flex flex-col gap-0.5 p-3">
            <ng-container *ngTemplateOutlet="routeDepartureRow; context: { $implicit: tl }"></ng-container>
            <div *ngIf="r.custom" class="mb-1 rounded-lg bg-violet-50 px-3 py-1.5 text-[11px] text-violet-700">
              Estás viendo el orden del optimizador; tu orden personalizado se conserva en la otra
              pestaña y es el que se confirma.
            </div>
            <div *ngFor="let stop of r.original; let i = index" class="flex flex-col rounded-md px-2 py-1">
              <ng-container *ngIf="tl && i > 0 && tl.stops.get(stop.orderId)?.trip !== tl.stops.get(r.original[i - 1].orderId)?.trip">
                <ng-container
                  *ngTemplateOutlet="reloadDivider; context: { $implicit: {
                    reload: tl.reloads[(tl.stops.get(stop.orderId)?.trip ?? 1) - 2],
                    trip: tl.stops.get(stop.orderId)?.trip
                  } }"></ng-container>
              </ng-container>
              <div class="flex items-center gap-3">
                <span
                  class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                  [style.background-color]="r.color">{{ i + 1 }}</span>
                <div class="min-w-0 flex-1">
                  <div class="flex min-w-0 items-center gap-1.5">
                    <div class="truncate text-sm font-medium text-slate-800">{{ stop.name }}</div>
                    <span *ngIf="stop.commercialName"
                      class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                      stop.commercialName }}</span>
                    <!-- Al FINAL del nombre y no delante: es un control, no un prefijo del
                       cliente. `shrink-0` para que el nombre trunque antes que el chip. -->
                    <ng-container
                      *ngTemplateOutlet="decisionMark; context: { $implicit: reviewStopDecisionOf(stop, r), id: stop.orderId }"></ng-container>
                  </div>
                  <div class="text-secondary truncate text-xs">{{ stop.address }}</div>
                </div>
                <span class="text-xs text-slate-400">{{ stop.weightLb | number: '1.0-1' }} lb</span>
                <ng-container
                  *ngTemplateOutlet="stopTimeColumn; context: { $implicit: tl && tl.stops.get(stop.orderId) }"></ng-container>
                <button mat-icon-button type="button" (click)="toggleDetail('review', stop.orderId)"
                  [attr.aria-expanded]="detailOpenIn('review') === stop.orderId" title="Ver pedidos y materiales"
                  aria-label="Ver pedidos y materiales">
                  <mat-icon class="icon-size-4" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
                </button>
              </div>
              <!-- El recorrido, en su propio panel y con su propio estado: cerrado no
                 ocupa nada. Hermano de la fila y no hijo, porque la fila no envuelve. -->
              <div *ngIf="decisionOpenId === stop.orderId" class="mb-1 ml-9">
                <ng-container
                  *ngTemplateOutlet="decisionTrail; context: { $implicit: reviewStopDecisionOf(stop, r) }"></ng-container>
              </div>
              <div *ngIf="detailOpenIn('review') === stop.orderId && detailOrdersIn('review') as detail"
                class="mb-1 ml-9 flex flex-col gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
                <ng-container
                  *ngTemplateOutlet="stopCostBlock; context: { $implicit: {
                    t: tl && tl.stops.get(stop.orderId),
                    cost: timelineStopCost(tl && tl.stops.get(stop.orderId), i === 0),
                    extra: detail.orders.length + ' pedido' + (detail.orders.length === 1 ? '' : 's')
                  } }"></ng-container>
                <ng-container *ngTemplateOutlet="ordersDetail; context: { $implicit: detail }"></ng-container>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="routeReturnRow; context: { $implicit: tl }"></ng-container>
          </div>
        </ng-template>

        <!-- Los controles de una ficha del pool, COMPARTIDOS por los dos modos.
             En el cuerpo común y no en una copia por modo: dos copias divergen a la
             primera corrección, y acá lo que divergiría es a qué rutas se puede
             añadir un pedido — la decisión entera de esta función. -->
        <ng-template #pendingActions let-item>
          <!-- Sin ninguna ruta que visite al cliente NO se ofrece el control: una ficha
               que no se puede soltar en ningún lado es peor que decir por qué. Y el
               arreglo no está en el reparto sino en el maestro. -->
          <span *ngIf="!pendingTargets(item).length" class="shrink-0 text-[11px] text-slate-500"
            title="Ninguna de las rutas por confirmar visita los territorios de este cliente. Se arregla en el maestro de rutas, no acá.">
            ninguna ruta visita su territorio
          </span>
          <!-- Añadir SIN arrastrar. En modo tarjetas es el camino principal: una ruta
               cerrada no tiene lista donde soltar, y abrir las diecisiete al levantar la
               ficha es justo el costo que esta pantalla ya evita.
               El conteo va SOBRE el control, como en el menú de mover: `1` es un destino
               forzado y `4` es margen real. -->
          <button *ngIf="pendingTargets(item).length as n" mat-stroked-button type="button"
            class="shrink-0" [matMenuTriggerFor]="addMenu"
            [title]="n === 1 ? '1 ruta puede recibirlo' : n + ' rutas pueden recibirlo'"
            aria-label="Añadir a una ruta">
            <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
            Añadir a… ({{ n }})
          </button>
          <mat-menu #addMenu="matMenu">
            <!-- El contenido se construye al ABRIR, pero la LISTA ya está calculada:
                 sale del memo que se llena junto con el pool, porque la ficha necesita
                 saber ANTES de abrir nada si hay a dónde ir. -->
            <ng-template matMenuContent>
              <button mat-menu-item *ngFor="let t of pendingTargets(item)"
                (click)="addPendingToRoute(item, t.route)">
                <span class="flex items-center gap-2">
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full"
                    [style.background-color]="t.route.color"></span>
                  <span class="font-medium">{{ t.route.label }}</span>
                  <!-- Todas las de la lista visitan un territorio del cliente: eso es lo
                       que las habilita, igual que al mover entre rutas. El desvío decide
                       ENTRE ellas, y va en km en línea recta, nunca en minutos: el motor
                       no evaluó esta secuencia. -->
                  <span class="text-secondary text-[11px]">
                    {{ t.detourKm === undefined ? 'sin medir' : '+' + (t.detourKm | number: '1.0-1') + ' km' }}
                  </span>
                </span>
              </button>
            </ng-template>
          </mat-menu>
        </ng-template>

        <!-- `tl` llega por contexto: se resuelve UNA vez por ruta. Llamarlo por fila
             reconstruiria el mapa de tiempos en cada parada. -->
        <ng-template #reviewCustomBody let-r let-tl="tl">
          <ng-container *ngTemplateOutlet="routeDepartureRow; context: { $implicit: tl }"></ng-container>
          <div class="flex flex-col gap-0.5 p-3" cdkDropList [cdkDropListData]="r"
            [cdkDropListEnterPredicate]="reviewEnterPredicate" (cdkDropListDropped)="onReviewDrop(r, $event)">
            <div *ngFor="let stop of r.stops; let i = index" cdkDrag
              class="flex flex-col rounded-md bg-white px-2 py-1 ring-1 ring-slate-100">
              <ng-container
                *ngIf="tl && i > 0 && tl.stops.get(stop.orderId)?.trip !== tl.stops.get(r.stops[i - 1].orderId)?.trip">
                <ng-container
                  *ngTemplateOutlet="reloadDivider; context: { $implicit: {
                    reload: tl.reloads[(tl.stops.get(stop.orderId)?.trip ?? 1) - 2],
                    trip: tl.stops.get(stop.orderId)?.trip
                  } }"></ng-container>
              </ng-container>
              <div class="flex items-center gap-3">
                <!-- El asa es TODA la ficha menos los botones: arrastrar desde un
                   iconito era apuntería fina; los ↑/↓ quedan fuera del asa para
                   que un clic en ellos nunca arranque un arrastre. -->
                <!-- pointerdown ≠ inicio del arrastre: CDK arranca tras un umbral de
                   movimiento, así que acá el layout se reacomoda (ocultar
                   incompatibles, abrir destinos) ANTES de que cachee geometría. -->
                <div cdkDragHandle class="flex min-w-0 flex-1 cursor-grab items-center gap-3"
                  (pointerdown)="beginReviewDrag(r, stop)">
                  <mat-icon class="icon-size-4 shrink-0 text-slate-300" svgIcon="heroicons_outline:bars-3"></mat-icon>
                  <span
                    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                    [style.background-color]="r.color">{{ i + 1 }}</span>
                  <div class="min-w-0 flex-1">
                    <div class="flex min-w-0 items-center gap-1.5">
                      <div class="truncate text-sm font-medium text-slate-800">{{ stop.name }}</div>
                      <span *ngIf="stop.commercialName"
                        class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                        stop.commercialName }}</span>
                      <!-- No salió del optimizador: distinguirla es lo que hace revisable
                         una lista donde conviven las dos procedencias. -->
                      <span *ngIf="stop.injected"
                        class="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700">
                        añadido
                      </span>
                      <!-- Al FINAL del nombre y de sus tags: es un control, no un prefijo. -->
                      <ng-container
                        *ngTemplateOutlet="decisionMark; context: { $implicit: reviewStopDecisionOf(stop, r), id: stop.orderId }"></ng-container>
                      <!-- El dato del maestro se declara, no se esconde: es la misma
                         decision que ya tomo `territoryMismatch` para las del plan. -->
                      <span *ngIf="reviewStopOutOfTerritory(r, stop)"
                        class="shrink-0 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700"
                        title="Esta ruta no visita ningún territorio del cliente. Sale igual porque vos lo decidiste; el arreglo de fondo es el maestro de rutas.">
                        fuera de territorio
                      </span>
                    </div>
                    <div class="text-secondary truncate text-xs">{{ stop.address }}</div>
                  </div>
                  <!-- No entro en el camion. Se declara EN la fila, con el motivo del
                     motor: la parada sigue ahi, sin tiempos. -->
                  <span *ngIf="unplacedReasonOf(r, stop) as motivo"
                    class="shrink-0 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700"
                    [title]="motivo">
                    no entra
                  </span>
                  <span class="text-xs text-slate-400">{{ stop.weightLb | number: '1.0-1' }} lb</span>
                  <!-- La columna COMPLETA, la misma que la lista del resultado. `tl` ya
                     paso por `recalcOf`, que es la unica puerta: un resultado obsoleto
                     no puede colarse aca, y sin recalculo no hay `tl` ni horas — no
                     ceros. -->
                  <ng-container
                    *ngTemplateOutlet="stopTimeColumn; context: { $implicit: tl && tl.stops.get(stop.orderId) }"></ng-container>
                </div>
                <span class="flex shrink-0 items-center">
                  <!-- Retirar CUALQUIER parada. No hace falta "devolverla" a ningun
                     lado: el pool se DERIVA de lo que no esta en ninguna ruta, asi que
                     sacarla de aca la hace aparecer alla sola.
                     Un solo boton y no dos: la accion y el resultado son los mismos, y
                     lo que cambia es el peso de la decision — eso va en el texto. Dos
                     controles para la misma operacion harian pensar que hacen cosas
                     distintas. -->
                  <button mat-icon-button type="button"
                    (click)="removePendingStop(r, i)"
                    [title]="stop.injected
                      ? 'Quitar de esta ruta: vuelve a la lista de no asignados, de donde la trajiste.'
                      : 'Sacar de esta ruta: pasa a la lista de no asignados y NO se entrega hoy, salvo que la vuelvas a asignar.'"
                    aria-label="Sacar de esta ruta">
                    <mat-icon class="icon-size-4 text-rose-500"
                      svgIcon="heroicons_outline:x-circle"></mat-icon>
                  </button>
                  <!-- Mover a otra ruta SIN arrastrar. Hasta ahora arrastrar era el
                     unico camino para cruzar: quien no puede arrastrar no podia, y en
                     el mosaico —con tiles de 10rem— arrastrar tampoco es comodo. Los
                     ↑/↓ de al lado solo reordenan DENTRO de la ruta.
                     Vive en el cuerpo que los dos modos comparten, no en una copia por
                     modo: dos copias divergen a la primera correccion, y esta es la
                     ultima palabra sobre el orden antes de persistir. -->
                  <!-- El conteo de destinos, SOBRE el control que ya existe. Antes el
                     disparador se veia identico con cinco destinos posibles y con
                     ninguno, asi que saber donde habia margen costaba catorce clics de
                     reconocimiento sobre informacion ya calculada.
                     Un conteo y no una marca de si/no: `1` es un movimiento forzado y
                     `5` es margen real, y no depende de que caso sea el raro en los
                     datos. Sin destinos NO lleva numero —la ausencia de una afirmacion,
                     no una negacion— y el disparador sigue accionable: abierto y vacio
                     explica, inhabilitado no diria nada. -->
                  <!-- No se ofrece para una parada AÑADIDA: esa se quita y se vuelve a
                     añadir donde corresponda. Ofrecer cruce ademas exigiria una segunda
                     regla de "a donde puede ir esto" dentro de la funcion que define la
                     primera. -->
                  <button *ngIf="!stop.injected" mat-icon-button type="button" class="relative"
                    [matMenuTriggerFor]="moveMenu"
                    [title]="reviewMoveTargetCount(r, stop)
                      ? ('Mover a otra ruta · ' + reviewMoveTargetCount(r, stop) + ' pueden recibirla')
                      : 'Mover a otra ruta'"
                    aria-label="Mover a otra ruta">
                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:arrow-right-circle"></mat-icon>
                    <span *ngIf="reviewMoveTargetCount(r, stop) as n"
                      class="absolute right-0.5 top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-indigo-500 px-1 text-[10px] font-bold leading-none text-white"
                      [attr.aria-label]="n + ' rutas pueden recibirla'">{{ n }}</span>
                  </button>
                  <mat-menu #moveMenu="matMenu">
                    <!-- `matMenuContent`: el contenido se construye al ABRIR. Sin esto
                       serian 14 filas × 17 rutas de cruce territorial por ciclo de
                       deteccion, que es el costo que esta plantilla ya evito una vez
                       con el `*ngIf="t.open"` de las paradas.
                       Y por eso el disparador NO se deshabilita: saber si hay destinos
                       exige calcularlos, y calcularlos para todas las filas por
                       adelantado es exactamente lo que se esta evitando. Abierto y
                       vacio ademas explica; inhabilitado no dice nada. -->
                    <ng-template matMenuContent>
                      <button mat-menu-item *ngFor="let t of reviewMoveTargets(r, stop)"
                        (click)="moveReviewStopTo(r, i, t.route)">
                        <span class="flex items-center gap-2">
                          <span class="h-2.5 w-2.5 shrink-0 rounded-full"
                            [style.background-color]="t.route.color"></span>
                          <span class="font-medium">{{ t.route.label }}</span>
                          <!-- El aval: es la RAZON por la que ese destino es valido
                             —una ruta no entrega donde no visita— y mostrarlo convierte
                             una lista de nombres en una lista de razones. -->
                          <span class="text-secondary text-[11px]">vía {{ t.sharedTerritory }}</span>
                        </span>
                      </button>
                      <div *ngIf="!reviewMoveTargets(r, stop).length"
                        class="px-4 py-3 text-xs text-slate-500">
                        No hay rutas que puedan recibir este pedido.
                      </div>
                    </ng-template>
                  </mat-menu>
                  <button mat-icon-button type="button" [disabled]="i === 0" (click)="moveReviewStopBy(r, i, -1)"
                    aria-label="Subir una posición">
                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:chevron-up"></mat-icon>
                  </button>
                  <button mat-icon-button type="button" [disabled]="i === r.stops.length - 1"
                    (click)="moveReviewStopBy(r, i, 1)" aria-label="Bajar una posición">
                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:chevron-down"></mat-icon>
                  </button>
                  <button mat-icon-button type="button" (click)="toggleDetail('review', stop.orderId)"
                    [attr.aria-expanded]="detailOpenIn('review') === stop.orderId" title="Ver pedidos y materiales"
                    aria-label="Ver pedidos y materiales">
                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
                  </button>
                </span>
              </div>
              <!-- El recorrido, en su propio panel y con su propio estado: cerrado no
                 ocupa nada. Hermano de la fila y no hijo, porque la fila no envuelve. -->
              <div *ngIf="decisionOpenId === stop.orderId" class="mb-1 ml-9 mt-1">
                <ng-container
                  *ngTemplateOutlet="decisionTrail; context: { $implicit: reviewStopDecisionOf(stop, r) }"></ng-container>
              </div>
              <div *ngIf="detailOpenIn('review') === stop.orderId && detailOrdersIn('review') as detail"
                class="mb-1 ml-9 mt-1 flex flex-col gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
                <ng-container
                  *ngTemplateOutlet="stopCostBlock; context: { $implicit: {
                    t: tl && tl.stops.get(stop.orderId),
                    cost: timelineStopCost(tl && tl.stops.get(stop.orderId), i === 0),
                    extra: detail.orders.length + ' pedido' + (detail.orders.length === 1 ? '' : 's')
                  } }"></ng-container>
                <ng-container *ngTemplateOutlet="ordersDetail; context: { $implicit: detail }"></ng-container>
              </div>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="routeReturnRow; context: { $implicit: tl }"></ng-container>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngIf="!reviewOpen">
      <!-- La corrida sigue: lo que ya llegó se ve mientras el resto se resuelve. -->
      <div *ngIf="isRunningGroups"
        class="flex flex-wrap items-center gap-3 rounded-2xl border border-indigo-100 bg-indigo-50 px-4 py-3">
        <mat-icon class="icon-size-5 animate-spin text-indigo-500" svgIcon="heroicons_outline:arrow-path"></mat-icon>
        <span class="text-sm font-semibold text-indigo-700">
          Resolviendo rutas… {{ groupsDone }} de {{ groupsTotal }}
        </span>
        <div class="h-1.5 w-40 overflow-hidden rounded-full bg-indigo-100">
          <div class="h-full rounded-full bg-indigo-500 transition-all"
            [style.width.%]="groupsTotal ? (groupsDone / groupsTotal) * 100 : 0"></div>
        </div>
      </div>

      <!-- Reintento SOLO de lo que falló. -->
      <div *ngIf="!isRunningGroups && failedGroups.length"
        class="flex flex-col gap-2 rounded-2xl border border-rose-100 bg-rose-50 px-4 py-3">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <span class="text-sm font-semibold text-rose-700">
            {{ failedGroups.length }} ruta(s) no se pudieron planificar.
          </span>
          <button mat-stroked-button color="warn" (click)="retryFailedGroups()">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            Reintentar solo las que fallaron
          </button>
        </div>
        <div *ngFor="let r of failureReasons" class="flex items-start gap-2 text-xs text-rose-800">
          <span class="mt-0.5 shrink-0 rounded-full bg-rose-100 px-2 font-bold">{{ r.count }}×</span>
          <span class="break-words">{{ r.message }}</span>
        </div>
      </div>

      <!-- CUANTOS entraron, y nada mas. El desglose por conjunto —con ruta y viaje /
         sin viaje— vivia aca y se retiro por decision: los dos conjuntos ya se
         recorren por separado en las pestanas de la grilla, y el encabezado del
         dialogo ya dice cual se pidio. `scopeCounts` sigue siendo la fuente de este
         total (`totalOrdersLoaded`). -->
      <div class="flex flex-wrap items-center gap-3 rounded-2xl border border-slate-100 bg-white px-4 py-3 shadow-sm">
        <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:queue-list"></mat-icon>
        <span class="text-xs font-semibold text-slate-700">
          {{ totalOrdersLoaded }} pedidos entraron a la optimización
        </span>
      </div>

      <!-- KPIs agregados -->
      <div class="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <div class="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
          <div class="flex items-center gap-2">
            <div class="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-50">
              <mat-icon class="text-indigo-500 icon-size-5" svgIcon="heroicons_outline:truck"></mat-icon>
            </div>
            <span class="text-secondary text-xs font-semibold tracking-wide">RUTAS PROPUESTAS</span>
          </div>
          <div class="mt-3 text-3xl font-extrabold text-slate-900">{{ dash.trucks }}</div>
        </div>

        <div class="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
          <div class="flex items-center gap-2">
            <div class="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-50">
              <mat-icon class="text-indigo-500 icon-size-5" svgIcon="heroicons_outline:map"></mat-icon>
            </div>
            <span class="text-secondary text-xs font-semibold tracking-wide">DISTANCIA TOTAL</span>
          </div>
          <div class="mt-3 text-3xl font-extrabold text-slate-900">{{ dash.distanceKm | number: '1.0-1' }} km</div>
        </div>

        <div class="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
          <div class="flex items-center gap-2">
            <div class="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-50">
              <mat-icon class="text-amber-500 icon-size-5" svgIcon="heroicons_outline:clock"></mat-icon>
            </div>
            <span class="text-secondary text-xs font-semibold tracking-wide">JORNADA DE LA FLOTA</span>
          </div>
          <div class="mt-3 text-3xl font-extrabold text-slate-900">{{ formatDuration(dash.workMin) }}</div>
          <!-- El desglose no es opcional: la atención suele ser la mayor parte del
             día, y un solo número la esconde tanto como el valor equivocado. -->
          <div class="text-secondary mt-1 text-xs">
            {{ formatDuration(dash.durationMin) }} en ruta · {{ formatDuration(dash.serviceMin) }} atendiendo
          </div>
        </div>

        <div class="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="flex h-9 w-9 items-center justify-center rounded-xl bg-teal-50">
                <mat-icon class="text-teal-500 icon-size-5" svgIcon="heroicons_outline:check-circle"></mat-icon>
              </div>
              <!-- CLIENTES, no pedidos: los pedidos de un mismo cliente se agrupan en
                 una visita, asi que una parada ES un cliente, y la cantidad de pedidos
                 se declara abajo — sin ella este contador y el de pedidos parecen no
                 cuadrar.
                 CAVEAT: el numero cuenta PARADAS. Cuando una visita se parte por
                 capacidad (`__sN`) un mismo cliente ocupa dos paradas y este contador
                 lo cuenta dos veces. En el caso normal parada = cliente; contar
                 clientes distintos exigiria deduplicar por `basePlanOrderId` en
                 `recomputeOfficeDash`, que cambia la semantica de `dash.assigned` y de
                 todo lo que la consume. -->
              <span class="text-secondary text-xs font-semibold tracking-wide">CLIENTES A VISITAR</span>
            </div>
          </div>
          <!-- CONTEO y no proporcion. El denominador disponible era `dash.total` —los
             clientes que LLEGARON al optimizador—, asi que el porcentaje media el
             rendimiento de esa etapa y se leia como cobertura: dejaba afuera a los que
             nunca llegaron. Y no se arregla cambiando el denominador: los que no
             llegaron nunca se agruparon en visitas, asi que "clientes cargados" no
             existe como dato. La cobertura vive en la cascada, donde cierra. -->
          <div class="mt-3 text-3xl font-extrabold text-slate-900">{{ dash.assigned }}</div>
          <!-- Solo la cantidad de pedidos. La ARITMETICA que la relaciona con las
             visitas —la resta de excluidos y la flecha— vivia tambien en la seccion
             de cada oficina ("N de M pedidos se optimizaron", los excluidos por su
             causa, y la nota de agrupacion cuando aplica), y con varias oficinas
             ademas en la tabla RESUMEN POR OFICINA. Era la copia mas pobre de tres:
             sin desglose y sin la regla. Las dos MAGNITUDES siguen juntas acá
             —visitas arriba, pedidos abajo—, que es lo que mantiene el conteo a la
             vista; lo que se fue es el calculo, a su unico lugar. -->
          <!-- Las dos MAGNITUDES juntas: clientes arriba, pedidos abajo. Son dos
             conteos sueltos y no una proporcion —eso se retiro—, asi que no insinuan
             una aritmetica entre si como lo hacia la fraccion `237 / 267`. La
             cobertura, con su resta y sus etapas, vive en la cascada. -->
          <div *ngIf="officeSummary" class="text-secondary mt-1 text-[11px]">
            {{ officeSummary.total.loaded }} pedidos
          </div>
        </div>
      </div>

      <!-- El KPI que justifica el optimizador: mismas paradas, mismo día, misma
         matriz del mapa — la única variable es el orden. Solo aparece cuando hay
         baseline de al menos una ruta, y declara su cobertura UNA vez, acá arriba:
         repetirla por valor la convierte en ruido y deja de leerse.

         Los CUATRO valores con el mismo peso. Antes el tiempo iba grande y los km,
         los galones y los lempiras como sub-datos de otro: eso escondia que un
         ahorro sin su base no se puede juzgar —87,4 km es el 5,9 % de 1.470 y el
         43,7 % de 200—. Cada tile trae su "sin optimizar → optimizado".

         Lo medido y lo estimado no se distinguen por TAMANO sino por una marca: el
         tamano insinuaba "el dinero importa menos", y no es cierto, es justamente lo
         que se lleva a una reunion. Lo que hay que declarar es la PROCEDENCIA. -->
      <div *ngIf="timeSaved as saved" class="flex flex-col gap-3 rounded-2xl border p-4 shadow-sm" [ngClass]="saved.minutes >= 0
        ? 'border-emerald-100 bg-emerald-50'
        : 'border-amber-100 bg-amber-50'">

        <div class="flex flex-wrap items-center gap-3">
          <!-- El icono ABRE la tabla del calculo. Antes era un `div` con `title` y
             `cursor-help`: parecia accionable y al hacer clic no pasaba nada, porque un
             `title` nativo solo aparece al pasar el mouse. Ahora es un boton, y el
             mismo estado que el enlace "¿Como se calcula?" — dos entradas al mismo
             contenido, las dos descubribles. -->
          <button type="button"
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-opacity hover:opacity-75"
            [ngClass]="saved.minutes >= 0 ? 'bg-emerald-100' : 'bg-amber-100'" [attr.aria-expanded]="methodOpen"
            aria-label="Ver cómo se calcula el ahorro"
            title="Cuánto mejora el plan propuesto frente al orden en que llegaron los pedidos, visitando las mismas paradas. Clic para ver el cálculo."
            (click)="methodOpen = !methodOpen">
            <mat-icon class="icon-size-5" [ngClass]="saved.minutes >= 0 ? 'text-emerald-600' : 'text-amber-600'"
              svgIcon="heroicons_outline:clock"></mat-icon>
          </button>
          <span class="text-xs font-semibold tracking-wide"
            [ngClass]="saved.minutes >= 0 ? 'text-emerald-700' : 'text-amber-700'">
            {{ saved.minutes >= 0 ? 'AHORRO DEL OPTIMIZADOR' : 'EL ORDEN ORIGINAL ERA MÁS CORTO' }}
          </span>
          <span class="text-secondary ml-auto text-[11px]">
            vs el orden en que llegan los pedidos, sin optimizar — mismas paradas y mismo mapa
            <ng-container *ngIf="saved.covered < saved.total">
              · sobre {{ saved.covered }} de {{ saved.total }} rutas</ng-container>
          </span>
        </div>

        <!-- `auto-fit` y no puntos de corte de ventana: el mosaico de rutas le compite
           el ancho a este bloque, asi que la ventana no sabe cuanto espacio le quedo.
           Con solo dos tiles —sin precio o sin rendimiento— los acomoda sin huecos. -->
        <div class="grid gap-3 grid-cols-[repeat(auto-fit,minmax(11rem,1fr))]">

          <!-- MEDIDO -->
          <div class="flex flex-col rounded-xl border border-white/60 bg-white/70 p-3"
            title="Cuánto menos se maneja en total con el plan propuesto, sumando todas las rutas.">
            <span class="text-[11px] font-semibold tracking-wide text-slate-500">TIEMPO</span>
            <span class="text-2xl font-extrabold text-slate-900">
              {{ formatDuration(saved.minutes < 0 ? -saved.minutes : saved.minutes) }} </span>
                <span class="text-secondary text-[11px]">
                  {{ formatDuration(saved.baselineMinutes) }} → {{ formatDuration(saved.optimizedMinutes) }}
                </span>
                <span class="text-[11px] font-semibold"
                  [ngClass]="saved.minutesPct >= 0 ? 'text-emerald-700' : 'text-amber-700'">
                  {{ saved.minutesPct >= 0 ? '−' : '+' }}{{ (saved.minutesPct < 0 ? -saved.minutesPct :
                    saved.minutesPct) | number: '1.0-1' }} % </span>
          </div>

          <!-- MEDIDO -->
          <div class="flex flex-col rounded-xl border border-white/60 bg-white/70 p-3"
            title="Cuántos kilómetros menos se recorren en total con el plan propuesto.">
            <span class="text-[11px] font-semibold tracking-wide text-slate-500">DISTANCIA</span>
            <span class="text-2xl font-extrabold text-slate-900">
              {{ (saved.km < 0 ? -saved.km : saved.km) | number: '1.0-1' }} km </span>
                <span class="text-secondary text-[11px]">
                  {{ saved.baselineKm | number: '1.0-0' }} → {{ saved.optimizedKm | number: '1.0-0' }} km
                </span>
                <span class="text-[11px] font-semibold"
                  [ngClass]="saved.kmPct >= 0 ? 'text-emerald-700' : 'text-amber-700'">
                  {{ saved.kmPct >= 0 ? '−' : '+' }}{{ (saved.kmPct < 0 ? -saved.kmPct : saved.kmPct) | number: '1.0-1'
                    }} % </span>
          </div>

          <!-- ESTIMADOS. El fondo rayado y el `~` en el rotulo los agrupan visualmente:
             estos dos salen de dos valores que cargo una persona, los de arriba los
             midio el motor de ruteo. Sin porcentaje a proposito: seria el MISMO que
             el de distancia —los dos derivan linealmente de los km— y repetirlo
             insinuaria tres mediciones donde hay una. -->
          <ng-container *ngIf="fuelSaved as fuel">
            <div class="flex flex-col rounded-xl border border-dashed border-slate-300 bg-white/40 p-3"
              title="Cuántos galones se dejan de consumir, según el rendimiento definido en el paso de selección. Es un estimado.">
              <span class="text-[11px] font-semibold tracking-wide text-slate-500">
                COMBUSTIBLE <span class="font-normal text-slate-400">~ estimado</span>
              </span>
              <span class="text-2xl font-extrabold text-slate-900">
                ~{{ (fuel.gallons < 0 ? -fuel.gallons : fuel.gallons) | number: '1.0-1' }} gal </span>
                  <span class="text-secondary text-[11px]">
                    {{ fuel.baselineGallons | number: '1.0-0' }} → {{ fuel.optimizedGallons | number: '1.0-0' }} gal
                  </span>
            </div>

            <div class="flex flex-col rounded-xl border border-dashed border-slate-300 bg-white/40 p-3"
              title="Cuánto menos se gasta en combustible, según el precio definido en el paso de selección. Es un estimado.">
              <span class="text-[11px] font-semibold tracking-wide text-slate-500">
                DINERO <span class="font-normal text-slate-400">~ estimado</span>
              </span>
              <span class="text-2xl font-extrabold text-slate-900">
                ~L {{ (fuel.lempiras < 0 ? -fuel.lempiras : fuel.lempiras) | number: '1.0-0' }} </span>
                  <span class="text-secondary text-[11px]">
                    L {{ fuel.baselineLempiras | number: '1.0-0' }} → L {{ fuel.optimizedLempiras | number: '1.0-0' }}
                  </span>
            </div>
          </ng-container>
        </div>

        <!-- De donde salen los dos estimados. Al pie y no por tile: es el mismo par de
           supuestos para los dos. -->
        <span *ngIf="fuelSaved" class="text-secondary text-[11px]">
          Combustible y dinero estimados con {{ kmPerGallon | number: '1.0-1' }} km/gal y
          L {{ fuelPricePerGallon | number: '1.0-2' }} por galón · el par de cada tile es
          <b>sin optimizar → optimizado</b>
        </span>
        <span *ngIf="!fuelSaved" class="text-secondary text-[11px]">
          Para ver el ahorro en combustible y en lempiras, falta definir el precio por galón
          y el rendimiento en el paso de selección.
        </span>

        <!-- La metodologia, DESPLEGABLE y cerrada por omision. Es lo que las cuatro
           estadisticas comparten, asi que repetirlo en cada tile seria ruido; y son
           ~700 caracteres, demasiado para un `title` nativo —se corta en algunos
           navegadores, no existe en touch y no se puede copiar—. Cada tile lleva SU
           formula en su `title`; aca vive lo comun. -->
        <div class="flex flex-col gap-1 border-t border-white/60 pt-2">
          <button type="button"
            class="flex w-fit items-center gap-1.5 text-[11px] font-semibold text-slate-600 hover:underline"
            [attr.aria-expanded]="methodOpen" (click)="methodOpen = !methodOpen">
            <mat-icon class="icon-size-4 transition-transform" [class.rotate-180]="methodOpen"
              svgIcon="heroicons_outline:chevron-down"></mat-icon>
            ¿Cómo se calcula?
          </button>
          <!-- La cuenta HECHA, con los numeros de esta corrida puestos: asi se puede
             verificar a mano en vez de creerla. Cada bloque es la operacion real que
             produce el tile de arriba, en el mismo orden. -->
          <!-- Una TABLA y no cuatro bloques apilados. Las columnas alineadas dejan que
             la resta se lea con los ojos, sin escribir la operacion: cada fila es
             "sin optimizar", "optimizado" y la diferencia, siempre igual. Antes cada
             estadistica traia su propio formato —la resta apilada, el porcentaje como
             expresion— y eran dos estilos para la misma cosa.
             Voz NEUTRA: es una estadistica de operaciones, no un mensaje al lector. -->
          <div *ngIf="methodOpen"
            class="flex flex-col gap-2 rounded-xl bg-white/70 p-3 text-[11px] leading-relaxed text-slate-700">

            <p>
              Se comparan dos recorridos con <b>las mismas paradas</b>: el orden en que llegaron
              los pedidos y el orden que propone el plan. Mismo mapa y mismo optimizador de ruteo, con
              la salida y el regreso al almacén incluidos en los dos.
            </p>
            <!-- La ESCALA, que faltaba: estos son totales de flota y el panel de
                 promedios de mas arriba muestra valores por ruta. Sin decirlo, "41 h de
                 viaje" contra "jornada 08:00-17:00" se lee como un error. -->
            <p>
              Los valores son los <b>totales de todas las rutas sumadas</b>, no los de una
              ruta: por eso las horas superan a la jornada de un día. Los promedios por ruta
              y por parada están más abajo, en <i>Promedios de la corrida</i>.
            </p>

            <!-- Los operadores VAN EN MEDIO, en columnas propias: asi cada fila se lee
               como la ecuacion que produce el tile —a − b = c— en vez de tres numeros
               que hay que adivinar como se combinan. -->
            <div class="overflow-x-auto">
              <table class="w-full tabular-nums">
                <thead>
                  <tr class="border-b border-slate-300 text-slate-500">
                    <th class="py-1 pr-3 text-left font-semibold">Concepto</th>
                    <th class="px-2 py-1 text-right font-semibold">Sin optimizar</th>
                    <th class="py-1"></th>
                    <th class="px-2 py-1 text-right font-semibold">Optimizado</th>
                    <th class="py-1"></th>
                    <th class="py-1 pl-2 text-right font-semibold">Ahorro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="border-b border-slate-200">
                    <td class="py-1 pr-3">Tiempo de viaje</td>
                    <td class="px-2 py-1 text-right">{{ formatDuration(saved.baselineMinutes) }}</td>
                    <td class="py-1 text-center text-slate-400">−</td>
                    <td class="px-2 py-1 text-right">{{ formatDuration(saved.optimizedMinutes) }}</td>
                    <td class="py-1 text-center text-slate-400">=</td>
                    <td class="py-1 pl-2 text-right font-bold text-slate-900">
                      {{ formatDuration(saved.minutes < 0 ? -saved.minutes : saved.minutes) }} <span
                        class="font-normal text-slate-500">
                        ({{ (saved.minutesPct < 0 ? -saved.minutesPct : saved.minutesPct) | number: '1.0-1' }} %)
                          </span>
                    </td>
                  </tr>
                  <tr class="border-b border-slate-200">
                    <td class="py-1 pr-3">Distancia</td>
                    <td class="px-2 py-1 text-right">{{ saved.baselineKm | number: '1.0-1' }} km</td>
                    <td class="py-1 text-center text-slate-400">−</td>
                    <td class="px-2 py-1 text-right">{{ saved.optimizedKm | number: '1.0-1' }} km</td>
                    <td class="py-1 text-center text-slate-400">=</td>
                    <td class="py-1 pl-2 text-right font-bold text-slate-900">
                      {{ (saved.km < 0 ? -saved.km : saved.km) | number: '1.0-1' }} km <span
                        class="font-normal text-slate-500">
                        ({{ (saved.kmPct < 0 ? -saved.kmPct : saved.kmPct) | number: '1.0-1' }} %) </span>
                    </td>
                  </tr>
                  <!-- Las dos filas estimadas, en italica: salen de parametros de la
                     pantalla, no de una medicion del mapa. -->
                  <ng-container *ngIf="fuelSaved as fuel">
                    <tr class="border-b border-slate-200 italic">
                      <td class="py-1 pr-3">Combustible</td>
                      <td class="px-2 py-1 text-right">{{ fuel.baselineGallons | number: '1.0-1' }} gal</td>
                      <td class="py-1 text-center not-italic text-slate-400">−</td>
                      <td class="px-2 py-1 text-right">{{ fuel.optimizedGallons | number: '1.0-1' }} gal</td>
                      <td class="py-1 text-center not-italic text-slate-400">=</td>
                      <td class="py-1 pl-2 text-right font-bold not-italic text-slate-900">
                        {{ (fuel.gallons < 0 ? -fuel.gallons : fuel.gallons) | number: '1.0-1' }} gal </td>
                    </tr>
                    <tr class="italic">
                      <td class="py-1 pr-3">Costo del combustible</td>
                      <td class="px-2 py-1 text-right">L {{ fuel.baselineLempiras | number: '1.0-0' }}</td>
                      <td class="py-1 text-center not-italic text-slate-400">−</td>
                      <td class="px-2 py-1 text-right">L {{ fuel.optimizedLempiras | number: '1.0-0' }}</td>
                      <td class="py-1 text-center not-italic text-slate-400">=</td>
                      <td class="py-1 pl-2 text-right font-bold not-italic text-slate-900">
                        L {{ (fuel.lempiras < 0 ? -fuel.lempiras : fuel.lempiras) | number: '1.0-0' }} </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <ul class="flex list-disc flex-col gap-1 pl-4 text-slate-500">
              <li>
                El porcentaje de cada fila es el ahorro sobre la columna
                <i>sin optimizar</i>.
              </li>
              <!-- Reconcilia los dos porcentajes, en las TRES direcciones. Sin esto,
                   "48 % menos de distancia pero solo 19 % menos de tiempo" se lee como
                   una cuenta mal hecha — y al reves tambien: mas ahorro de tiempo que de
                   distancia es igual de raro. La primera version solo explicaba el caso
                   de velocidad a la baja, asi que el hueco cambiaba de lugar en vez de
                   cerrarse. El texto lo arma `speedNote`, que nombra los dos recorridos
                   porque el tablero de arriba ya muestra otra velocidad media. -->
              <li *ngIf="speedNote as nota">{{ nota }}</li>
              <li>
                Del tiempo solo se compara el <b>viaje</b>. La atención en cada parada es la
                misma en los dos recorridos, así que no cambia el resultado.
              </li>
              <li *ngIf="fuelSaved">
                El combustible y su costo son <b>estimados</b>: se calculan con
                {{ kmPerGallon | number: '1.0-1' }} km por galón y L
                {{ fuelPricePerGallon | number: '1.0-2' }} por galón, definidos en el paso de
                selección. El rendimiento es un promedio: el consumo real varía con la carga.
              </li>
              <li *ngIf="fuelSaved">
                La columna <i>sin optimizar</i> del costo es lo que el día habría costado en
                combustible; la de <i>optimizado</i>, lo que cuesta con el plan.
              </li>
              <li *ngIf="saved.covered < saved.total">
                Incluye {{ saved.covered }} de {{ saved.total }} rutas: el recorrido sin
                optimizar de las demás no se pudo medir.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Resumen por oficina: la cadena de conciliación COMPLETA, en una tabla que
         cierra contra sí misma (los totales se suman de las filas). Solo con más
         de una oficina: con una sola, su propia sección ya cuenta esta historia y
         la tabla sería un eco. -->
      <div *ngIf="officeSummary && officeSummary.rows.length > 1"
        class="flex flex-col gap-2 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:building-office-2"></mat-icon>
          <span class="text-xs font-semibold tracking-wide text-slate-700">RESUMEN POR OFICINA</span>
          <span class="text-secondary text-[11px]">
            pedidos − excluidos → ubicadas + sin ubicar (un cliente = una visita)
          </span>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full min-w-[40rem] text-xs">
            <thead>
              <tr class="text-secondary text-left [&>th]:py-1.5 [&>th]:pr-4 [&>th]:font-semibold">
                <th>Oficina</th>
                <th class="text-right">Pedidos</th>
                <th class="text-right">Excluidos</th>
                <th class="text-right">Ubicadas</th>
                <th class="text-right">Sin ubicar</th>
                <th class="text-right">Rutas</th>
                <th class="text-right">Km</th>
                <th class="text-right">Jornada</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of officeSummary.rows" class="border-t border-slate-100 [&>td]:py-1.5 [&>td]:pr-4">
                <td class="font-medium text-slate-800">
                  {{ r.name }}
                  <span *ngIf="r.error"
                    class="ml-1 rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-bold text-rose-600"
                    [title]="r.error">error de carga</span>
                </td>
                <td class="text-right">{{ r.loaded }}</td>
                <td class="text-right" [class.text-amber-600]="r.excluded" [class.font-semibold]="r.excluded">
                  {{ r.excluded }}
                </td>
                <td class="text-right font-semibold text-emerald-700">{{ r.placed }}</td>
                <td class="text-right" [class.text-rose-600]="r.unplaced" [class.font-semibold]="r.unplaced">
                  {{ r.unplaced }}
                </td>
                <td class="text-right">{{ r.routes }}</td>
                <td class="text-right">{{ r.distanceKm | number: '1.0-0' }}</td>
                <td class="text-right">{{ formatDuration(r.workMin) }}</td>
              </tr>
              <tr class="border-t-2 border-slate-200 font-bold text-slate-900 [&>td]:py-1.5 [&>td]:pr-4">
                <td>Total</td>
                <td class="text-right">{{ officeSummary.total.loaded }}</td>
                <td class="text-right">{{ officeSummary.total.excluded }}</td>
                <td class="text-right">{{ officeSummary.total.placed }}</td>
                <td class="text-right">{{ officeSummary.total.unplaced }}</td>
                <td class="text-right">{{ officeSummary.total.routes }}</td>
                <td class="text-right">{{ officeSummary.total.distanceKm | number: '1.0-0' }}</td>
                <td class="text-right">{{ formatDuration(officeSummary.total.workMin) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Promedios de la corrida. La velocidad es un RESULTADO observado, no un
         parámetro: el servicio de ruteo no recibe una velocidad, la deriva del
         mapa (OSM). Por eso no hay control para ajustarla. -->
      <div *ngIf="averages.routes"
        class="flex flex-col gap-3 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:calculator"></mat-icon>
          <span class="text-xs font-semibold tracking-wide text-slate-700">PROMEDIOS DE LA CORRIDA</span>
        </div>

        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div class="text-secondary text-[10px] font-semibold tracking-wide">VELOCIDAD MEDIA SUGERIDA</div>
            <div class="text-lg font-bold text-slate-900">
              <ng-container *ngIf="averages.fleetKmh !== null; else noSpeed">
                {{ averages.fleetKmh | number: '1.0-1' }} km/h
              </ng-container>
              <ng-template #noSpeed><span class="text-slate-400">—</span></ng-template>
            </div>
            <div *ngIf="averages.slowestKmh !== null" class="text-secondary text-[10px]">
              entre {{ averages.slowestKmh | number: '1.0-1' }} y {{ averages.fastestKmh | number: '1.0-1' }} por ruta
            </div>
          </div>

          <div>
            <div class="text-secondary text-[10px] font-semibold tracking-wide">VIAJE POR PARADA</div>
            <div class="text-lg font-bold text-slate-900">
              {{ averages.travelPerStopMin | number: '1.0-1' }} min
            </div>
            <div class="text-secondary text-[10px]">{{ averages.stops }} paradas planificadas</div>
          </div>

          <div>
            <div class="text-secondary text-[10px] font-semibold tracking-wide">ATENCIÓN POR PARADA</div>
            <div class="text-lg font-bold text-slate-900">
              {{ averages.servicePerStopMin | number: '1.0-1' }} min
            </div>
            <!-- Declarado como SUPUESTO: de él depende que el plan sea factible. -->
            <div class="text-[10px] font-medium text-amber-700"
              title="Es un valor asumido por la pantalla, no medido de la operación. Los recorridos se planifican pegados al límite del turno, así que una atención mayor los volvería imposibles.">
              supuesto: {{ assumedServiceMin }} min por parada
            </div>
            <!-- La jornada también es un supuesto, y es el que decide cuántos pedidos
               entran: el maestro de sub-rutas no declara horario, así que este número
               sale de la pantalla. Declararlo es lo que evita leer "el camión no está
               lleno" cuando lo que se llenó fue el día. -->
            <div class="text-[10px] font-medium text-amber-700"
              title="La jornada no viene del maestro de sub-rutas: es la franja elegida en la pantalla. Es el límite que deja pedidos fuera cuando el camión todavía tiene espacio de carga.">
              jornada: {{ assumedShift.start }}–{{ assumedShift.end }} ({{ formatDuration(shiftMin) }})
            </div>
          </div>

          <div>
            <div class="text-secondary text-[10px] font-semibold tracking-wide">JORNADA POR RUTA</div>
            <div class="text-lg font-bold text-slate-900">
              {{ formatDuration(averages.workPerRouteMin) }}
            </div>
            <div class="text-secondary text-[10px]">
              de un turno de {{ formatDuration(shiftMin) }}
            </div>
          </div>
        </div>

        <!-- Estos cuatro son PROMEDIOS —por parada o por ruta— y el bloque de ahorro de
             mas arriba muestra TOTALES de flota. Dos escalas en la misma pantalla: sin
             decir cual es cual, "41 h de viaje" contra "6 h 41 min de jornada por ruta"
             se lee como una contradiccion. -->
        <div class="flex flex-col gap-1 border-t border-slate-100 pt-2">
          <button type="button"
            class="flex w-fit items-center gap-1.5 text-[11px] font-semibold text-slate-600 hover:underline"
            [attr.aria-expanded]="averagesMethodOpen"
            (click)="averagesMethodOpen = !averagesMethodOpen">
            <mat-icon class="icon-size-4 transition-transform" [class.rotate-180]="averagesMethodOpen"
              svgIcon="heroicons_outline:chevron-down"></mat-icon>
            ¿Cómo se calcula?
          </button>
          <div *ngIf="averagesMethodOpen"
            class="flex flex-col gap-2 rounded-xl bg-slate-50 p-3 text-[11px] leading-relaxed text-slate-700">
            <p>
              Son <b>promedios</b> de las {{ averages.routes }} rutas del plan, no totales. El
              bloque de ahorro de más arriba, en cambio, suma todas las rutas: por eso ahí las
              horas superan a la jornada de un día.
            </p>
            <ul class="flex list-disc flex-col gap-1 pl-4 text-slate-500">
              <li>
                <b>Velocidad media</b>: los kilómetros de toda la flota divididos por sus horas
                de viaje. Es un <b>resultado observado</b>, no un parámetro: al optimizador
                no se le indica una velocidad, la deriva del mapa. El rango muestra la ruta más
                lenta y la más rápida.
              </li>
              <li>
                <b>Viaje por parada</b>: los minutos de viaje de toda la flota divididos por las
                {{ averages.stops }} paradas planificadas.
              </li>
              <li>
                <b>Atención por parada</b>: los minutos de atención divididos por las mismas
                paradas. Coincide con el supuesto porque la pantalla usa el mismo valor en cada
                parada.
              </li>
              <li>
                <b>Jornada por ruta</b>: viaje más atención de toda la flota, dividido por las
                rutas. Es lo que ocupa un día de trabajo, y se compara contra el turno para ver
                cuánto margen queda.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Tabs Lista | Mapa, con los tags de entrega en la MISMA fila -->
      <div class="flex flex-wrap items-center gap-x-3 gap-y-2">
        <div class="flex w-fit shrink-0 rounded-lg border border-slate-200 bg-white p-0.5">
          <button type="button" class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium"
            [class.bg-indigo-500]="activeTab === 'list'" [class.text-white]="activeTab === 'list'"
            (click)="activeTab = 'list'">
            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:list-bullet"></mat-icon> Lista
          </button>
          <button type="button" class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium"
            [class.bg-indigo-500]="activeTab === 'map'" [class.text-white]="activeTab === 'map'"
            (click)="activeTab = 'map'">
            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:map"></mat-icon> Mapa
          </button>
        </div>

        <!-- Selector de MODO de las rutas propuestas. Solo con la pestaña de lista
           activa: con el mapa abierto seria un control que no produce ningun efecto
           al accionarlo, el mismo criterio que los tags de entrega.
           Se rotula "Tarjetas | Grid" y no "Lista | Grid" a proposito: "Lista" ya es
           la pestaña de al lado, y dos controles pegados con la misma palabra para
           cosas distintas —que estas mirando vs. como se acomodan las rutas— se leen
           como el mismo control. -->
        <div *ngIf="activeTab === 'list'" class="flex w-fit shrink-0 rounded-lg border border-slate-200 bg-white p-0.5">
          <button type="button" class="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium"
            [class.bg-slate-900]="viewMode === 'list'" [class.text-white]="viewMode === 'list'"
            [attr.aria-pressed]="viewMode === 'list'" (click)="viewMode = 'list'">
            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:bars-3"></mat-icon> Tarjetas
          </button>
          <button type="button" class="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium"
            [class.bg-slate-900]="viewMode === 'grid'" [class.text-white]="viewMode === 'grid'"
            [attr.aria-pressed]="viewMode === 'grid'" (click)="viewMode = 'grid'">
            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:squares-2x2"></mat-icon> Grid
          </button>
        </div>

        <!-- Tags de entrega: el filtro por sub-ruta que la lista nunca tuvo. El
           selector del mapa no servia tal cual —recorta el geojson y es de una a
           la vez, para poder seguir UN recorrido—; aca la pregunta es "comparemos
           estas tres".
           Solo en modo lista: es lo que filtran. Visibles con el mapa abierto
           serian un control que no produce ningun efecto al accionarlo.
           Con una sola entrega el control no filtra nada y no se muestra. -->
        <ng-container *ngIf="activeTab === 'list' && routeTags.length > 1">
          <button *ngFor="let tag of routeTags" type="button" (click)="toggleTag(tag)"
            [attr.aria-pressed]="tagActive(tag)"
            [title]="tag.label + ' · ' + tag.stops + ' paradas enviadas al optimizador'"
            class="flex shrink-0 items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold transition-colors"
            [class.border-slate-200]="!tagActive(tag)" [class.bg-white]="!tagActive(tag)"
            [class.text-slate-600]="!tagActive(tag)" [class.hover:bg-slate-50]="!tagActive(tag)"
            [class.border-transparent]="tagActive(tag)" [class.bg-slate-900]="tagActive(tag)"
            [class.text-white]="tagActive(tag)">
            <!-- El mismo color de su tarjeta y de sus pines: el tag es tambien la
               leyenda que relacionaba color con ruta y no existia. -->
            <span class="h-2.5 w-2.5 shrink-0 rounded-full" [style.background-color]="tag.color"></span>
            {{ tag.label }}
            <span class="opacity-70">{{ tag.stops }}</span>
          </button>
          <button *ngIf="selectedTagCount" type="button" (click)="clearTags()"
            class="shrink-0 text-xs font-semibold text-indigo-600 hover:underline">
            limpiar ({{ selectedTagCount }})
          </button>
        </ng-container>
      </div>

      <!-- Lista: una sección por oficina -->
      <div *ngIf="activeTab === 'list'" class="flex flex-col gap-6">
        <!-- Búsqueda: vive DENTRO de la pestaña Lista —que es donde actúa; el mapa
           no se filtra— y FUERA del bucle de oficinas, porque el control es
           global: filtra las tres listas de todas las oficinas y su resumen las
           cuenta a todas. Dentro del bucle se renderizaría una caja por oficina,
           todas atadas al mismo texto. -->
        <div class="flex flex-wrap items-center gap-3">
          <mat-form-field appearance="fill" class="min-w-72 flex-1" subscriptSizing="dynamic">
            <mat-label>Buscar cliente, ruta o territorio</mat-label>
            <mat-icon matPrefix class="icon-size-5 text-slate-400 mr-2"
              svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
            <input matInput [ngModel]="searchText" (ngModelChange)="onSearchChange($event)"
              placeholder="Ej.: ORDO, ENTREGA 306, COMAYAGUA" autocomplete="off" />
            <button *ngIf="searchText" mat-icon-button matSuffix (click)="clearSearch()" aria-label="Limpiar búsqueda">
              <mat-icon class="icon-size-5" svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
          </mat-form-field>
          <span *ngIf="filterActive && searchSummaryText"
            class="rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold text-indigo-600">
            {{ searchSummaryText }}
          </span>
        </div>

        <!-- Estado vacío propio: no es "el plan no produjo rutas". -->
        <div *ngIf="!hasSearchResults"
          class="flex items-center gap-3 rounded-2xl border border-slate-100 bg-slate-50 p-4">
          <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
          <span class="text-sm text-slate-600">
            Sin resultados<ng-container *ngIf="searchText"> para
              <b>{{ searchText }}</b></ng-container><ng-container *ngIf="selectedTagCount"> en las
              entregas seleccionadas</ng-container> — ni en las rutas, ni en los pedidos que quedaron
            fuera.
          </span>
        </div>

        <div *ngFor="let op of officePlans" class="flex flex-col gap-4">
          <!-- Encabezado de la oficina -->
          <div
            class="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
            <div class="flex items-center gap-3">
              <span
                class="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500/10 to-violet-500/10">
                <mat-icon class="icon-size-5 text-indigo-500" svgIcon="heroicons_outline:building-office-2"></mat-icon>
              </span>
              <div>
                <div class="text-base font-bold text-slate-900">{{ op.office.name }}</div>
                <div class="text-secondary text-xs">
                  {{ op.ordersCount }} pedidos
                  <!-- SIN la fraccion de visitas ubicadas: era la que ponia una
                     segunda unidad al lado de un contador en pedidos, y la cascada de
                     cobertura ya declara las dos magnitudes en su nivel. -->
                  <ng-container *ngIf="op.dash">
                    · {{ routesLabelOf(op) }} · {{ op.dash.distanceKm | number: '1.0-1' }} km
                    · jornada {{ formatDuration(op.dash.workMin) }}
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Cobertura como CASCADA, no como fila plana.
             La fila decia "283 de 289 pedidos se optimizaron" y debajo listaba los
             descuentos: unos ya restados de ese 283 y otros no, asi que la suma no
             cerraba y la conclusion razonable era que se habian perdido pedidos.
             `plannable` no es un resultado —se calcula antes del optimizador y solo
             dice que el pedido tiene coordenadas e identidad—, asi que el titular
             pasa a ser cuantos quedaron EN RUTA. Cada descuento cuelga del nivel del
             que se resta y sigue abriendo la misma lista que abria. -->
          <div *ngIf="coverageFunnelOf(op) as funnel"
            class="flex flex-col gap-2 rounded-2xl border border-slate-100 bg-white px-4 py-3 shadow-sm">
            <div class="flex flex-wrap items-center gap-3">
              <mat-icon class="icon-size-5 text-slate-400"
                svgIcon="heroicons_outline:clipboard-document-check"></mat-icon>
              <span class="text-sm font-bold text-slate-900">{{ funnel.headline }}</span>
              <!-- Lo que no entro, dicho y no deducido: es exactamente el numero que
                 el operador estaba tratando de calcular sumando los chips. -->
              <span *ngIf="funnel.droppedLabel"
                class="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600">
                {{ funnel.droppedLabel }}
              </span>
            </div>

            <div class="flex flex-col gap-1 pl-8">
              <ng-container *ngFor="let nivel of funnel.levels; trackBy: trackFunnelLevel">
                <div class="flex flex-wrap items-baseline gap-2 text-xs">
                  <span class="w-12 shrink-0 text-right font-bold text-slate-700">{{ nivel.count }}</span>
                  <span class="text-secondary">{{ nivel.label }}</span>
                  <!-- La UNICA vez que se nombran las visitas en la cascada, y como
                     magnitud paralela: dos unidades dentro de una misma resta no
                     cierran por construccion. -->
                  <span *ngIf="nivel.aside" class="text-[11px] text-slate-400">{{ nivel.aside }}</span>
                </div>
                <ng-container *ngFor="let d of nivel.drops; trackBy: trackFunnelDrop">
                  <!-- El descuento ES el acordeon. Con fondo propio, chevron que rota y
                     `aria-expanded`: sin las tres senales se leia como un renglon mas de
                     la aritmetica y la unica puerta a esos pedidos pasaba inadvertida. -->
                  <button type="button" (click)="openDropTarget(op, d.target)" [title]="d.hint || ''"
                    [attr.aria-expanded]="dropOpen(op, d.target)"
                    class="flex w-fit items-start gap-2 rounded-lg border border-amber-100 bg-amber-50 px-2 py-1 text-left text-xs transition-colors hover:bg-amber-100">
                    <span class="w-10 shrink-0 text-right font-bold text-amber-700">−{{ d.count }}</span>
                    <span class="flex min-w-0 flex-col">
                      <span class="font-semibold text-amber-800">{{ d.label }}</span>
                      <!-- Los motivos SIN cuentas: la cantidad ya la trae el descuento, y
                         las de los motivos van por visita. Cuantos hay por motivo se lee
                         dentro del panel. -->
                      <span *ngIf="dropSubtitle(op, d.target) as sub" class="text-[11px] text-amber-600">
                        {{ sub }}
                      </span>
                    </span>
                    <mat-icon class="icon-size-4 shrink-0 self-center text-amber-500 transition-transform"
                      [class.rotate-180]="dropOpen(op, d.target)"
                      svgIcon="heroicons_outline:chevron-down"></mat-icon>
                  </button>
                  <!-- El panel, a ancho completo y no dentro de la sangria: las listas son
                     bloques grandes y anidadas en la sangria quedaban apretadas. -->
                  <div *ngIf="dropOpen(op, d.target)" class="-ml-8 mb-1">
                    <ng-container
                      [ngTemplateOutlet]="d.target === 'excluded' ? excludedList
                        : d.target === 'fleet-gap' ? fleetGapList : unassignedList"
                      [ngTemplateOutletContext]="{ $implicit: op }"></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <!-- FUERA de la cascada: no resta nada. Es una anotacion de procedencia
               sobre pedidos que SI entraron, y puesta entre los descuentos se leia
               como un cubo aparte del que habia que preguntar en que se diferenciaba
               del total. No se diferencia: esta dentro. -->
            <div *ngIf="op.coverage.autoAssigned" class="border-t border-slate-100 pt-2 pl-8">
              <span class="text-[11px] text-slate-500" [title]="op.autoAssignedNotes.join('&#10;')">
                {{ op.coverage.autoAssigned }} de los que quedaron en ruta traían su territorio
                resuelto por la partición, no por su propia ruta.
              </span>
            </div>
          </div>

          <!-- Decisiones y avisos de flota de la corrida: a qué territorio se asignó
             cada camión disputado y de cuál lo quitó, más lo que no se pudo
             dimensionar. Se renderizan acá porque antes NO se renderizaban en
             ninguna parte: se escribían en la vista y se perdían, que es la forma
             más silenciosa de decidir por el operador. -->
          <div *ngIf="op.fleetWarnings.length"
            class="flex flex-col gap-1 rounded-2xl border border-amber-200 bg-amber-50 p-4">
            <span *ngFor="let w of op.fleetWarnings" class="text-xs text-amber-900">{{ w }}</span>
          </div>

          <!-- Estado por ruta, colapsable: un chip por TERRITORIO con flota, así
             que su cantidad está acotada por los camiones asignados. El
             encabezado agrega las dos señales por separado: cómo se planificó lo
             que tiene camión, y qué territorios no tienen con qué salir. -->
          <div *ngIf="showGroupsPanel && op.groups.length"
            class="overflow-hidden rounded-2xl border border-slate-100 bg-white">
            <button type="button" class="flex w-full items-center justify-between gap-2 p-4 text-left"
              (click)="op.groupsOpen = !op.groupsOpen">
              <span class="flex min-w-0 flex-col gap-0.5">
                <span class="flex items-center gap-2 text-sm font-semibold text-slate-700">
                  <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:list-bullet"></mat-icon>
                  Detalle por ruta ({{ op.groups.length }})
                </span>
                <span *ngIf="groupsSummaryOf(op)" class="pl-7 text-xs font-medium text-amber-700">
                  {{ groupsSummaryOf(op) }}
                </span>
                <!-- La brecha va en su propio renglón: no describe cómo se planificó
                   algo, describe lo que hoy no puede salir. -->
                <span *ngIf="fleetGapSummaryOf(op)" class="pl-7 text-xs font-medium text-rose-700">
                  {{ fleetGapSummaryOf(op) }}
                </span>
              </span>
              <mat-icon class="icon-size-5 text-slate-400 transition-transform" [class.rotate-180]="op.groupsOpen"
                svgIcon="heroicons_outline:chevron-down"></mat-icon>
            </button>
            <div *ngIf="op.groupsOpen" class="flex flex-wrap items-center gap-2 px-4 pb-4">
              <span *ngFor="let g of op.groups"
                class="flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold" [ngClass]="{
                'bg-slate-100 text-slate-500': g.status === 'pending',
                'bg-indigo-50 text-indigo-600': g.status === 'running',
                'bg-emerald-50 text-emerald-700': g.status === 'done',
                'bg-rose-50 text-rose-700': g.status === 'failed'
              }" [title]="g.error || g.warnings.join(' ') || g.label">
                {{ g.label }} · {{ g.stops }}
                <mat-icon *ngIf="!g.fleetFromMaster" class="icon-size-4 text-amber-500"
                  svgIcon="heroicons_outline:exclamation-triangle"
                  title="Camión y jornada por defecto: el maestro de esta ruta no los declara"></mat-icon>
              </span>
            </div>
          </div>

          <!-- Error de la carga de esta oficina -->
          <div *ngIf="op.error" class="flex items-center gap-3 rounded-2xl border border-rose-100 bg-rose-50 p-4">
            <mat-icon class="text-rose-500 icon-size-5" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
            <span class="text-sm font-semibold text-rose-700">{{ op.error }}</span>
          </div>

          <!-- Se planifico con PARTE de los pedidos: un plan sobre un subconjunto
             silencioso se lee como completo. -->
          <div *ngIf="op.ordersWarning"
            class="flex items-start gap-3 rounded-2xl border border-amber-100 bg-amber-50 p-4">
            <mat-icon class="text-amber-500 icon-size-5 shrink-0"
              svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
            <span class="text-xs text-amber-900">{{ op.ordersWarning }}</span>
          </div>

          <!-- Sin pedidos para esta oficina -->
          <div *ngIf="!op.error && !op.ordersCount"
            class="flex items-center gap-3 rounded-2xl border border-amber-100 bg-amber-50 p-4">
            <mat-icon class="text-amber-500 icon-size-5" svgIcon="heroicons_outline:inbox"></mat-icon>
            <span class="text-sm font-medium text-amber-700">Sin pedidos en el alcance para esta oficina.</span>
          </div>

          <!-- Tarjeta por ruta propuesta -->
          <ng-container *ngIf="viewMode === 'list'">
            <div *ngFor="let t of op.truckViews" [hidden]="filterActive && !truckHits(t)"
              class="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-shadow hover:shadow-md">
              <!-- El encabezado entero es el disparador: es la zona grande y obvia, y
               una ruta cerrada no tiene otra cosa en la que hacer clic. -->
              <div class="flex cursor-pointer flex-wrap items-center justify-between gap-3 border-l-4 p-4"
                [style.border-left-color]="t.color" role="button" tabindex="0" [attr.aria-expanded]="t.open"
                (click)="toggleTruck(t)" (keydown.enter)="toggleTruck(t)" (keydown.space)="toggleTruck(t)">
                <div class="flex items-center gap-3">
                  <!-- Ver esta ruta en el mapa. Aca el mapa del plan es cierto sin mas:
                     lo que se dibuja ES el plan. `stopPropagation` porque el encabezado
                     entero colapsa la tarjeta. -->
                  <button mat-icon-button type="button"
                    (click)="$event.stopPropagation(); openRouteOnMap(t.truckId)"
                    title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                    <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:map"></mat-icon>
                  </button>
                  <span class="flex h-9 w-9 items-center justify-center rounded-xl" [style.background-color]="t.color">
                    <mat-icon class="icon-size-5 text-white" svgIcon="heroicons_solid:truck"></mat-icon>
                  </span>
                  <div>
                    <div class="flex items-center gap-2">
                      <!-- La RUTA como título; el territorio va debajo, rotulado. Ruta y
                       territorio comparten número y se distinguen por el prefijo
                       (ENTREGA 303 / COMAYAGUA 303): un valor suelto es
                       indistinguible del otro concepto. -->
                      <span class="text-sm font-bold text-slate-900">{{ t.subRouteName }}</span>
                      <span *ngIf="t.trips > 1"
                        class="rounded-full bg-violet-50 px-2 py-0.5 text-[10px] font-bold text-violet-600">
                        {{ t.trips }} viajes
                      </span>
                      <!-- Resultado de confirm-optimized-routes para esta subruta, si ya se confirmó. -->
                      <span *ngIf="resultFor(t) as r" [title]="r.error || ''" [class]="r.status === 'ok'
                      ? 'rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-600'
                      : 'rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-bold text-rose-600'">
                        {{ r.status === 'ok' ? (r.created ? '✓ Viaje creado' : '✓ Confirmada') : '✗ Error al confirmar'
                        }}
                      </span>
                    </div>
                    <div class="text-secondary flex flex-wrap items-center gap-1.5 text-xs">
                      <span *ngIf="t.territoryName"
                        class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
                        Territorio {{ t.territoryName }}
                      </span>
                      <span>{{ t.vehicleLabel }}</span>
                    </div>
                  </div>
                </div>
                <div class="text-secondary flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-medium">
                  <ng-container *ngTemplateOutlet="truckMetaRow; context: { $implicit: t }"></ng-container>
                  <!-- Los totales de arriba son de la RUTA COMPLETA: los km y la
                   jornada de un subconjunto describirían un recorrido que el
                   camión no hace. El filtro se declara, no se recalcula. -->
                  <span *ngIf="searchActive" class="rounded-full bg-indigo-50 px-2 py-0.5 font-bold text-indigo-600">
                    {{ truckHits(t) }} de {{ t.stops.length }} paradas coinciden
                  </span>
                  <!-- Sin texto no hay "coincidencias" que declarar: el tag ya dice
                   cual entrega se esta mirando. -->
                  <mat-icon class="icon-size-5 text-slate-400 transition-transform" [class.rotate-180]="t.open"
                    svgIcon="heroicons_outline:chevron-down"></mat-icon>
                </div>
              </div>

              <!-- Barra de capacidad -->
              <div class="px-4 pb-2">
                <div class="flex items-center justify-between text-xs">
                  <span class="text-secondary font-medium">
                    Capacidad{{ t.trips > 1 ? ' (viaje más cargado)' : '' }}
                  </span>
                  <span class="font-semibold text-slate-700">
                    {{ t.heaviestTripLb | number: '1.0-0' }} / {{ t.capacityLb | number: '1.0-0' }} lb
                    <span class="text-secondary font-normal">
                      (~{{ t.heaviestTripKg | number: '1.0-0' }} / {{ t.capacityKg | number: '1.0-0' }} kg)
                    </span>
                    · {{ t.capacityPct | number: '1.0-0' }}%
                    <span *ngIf="t.trips > 1" class="text-secondary font-normal">
                      · total del día: {{ t.weightLb | number: '1.0-0' }} lb
                    </span>
                  </span>
                </div>
                <div class="mt-1 h-2 w-full overflow-hidden rounded-full bg-slate-100">
                  <div class="h-full rounded-full transition-all" [style.width.%]="t.capacityPct"
                    [style.background-color]="t.capacityPct > 90 ? '#f43f5e' : t.color"></div>
                </div>
              </div>

              <!-- Paradas (agrupadas por viaje; recarga entre viajes).
               `*ngIf` y no una clase CSS: cerradas NO se construyen. Son 17 rutas
               x ~14 paradas x ~10 nodos en la corrida real, y con la lista armada
               cada tecla del buscador reevaluaba las 246 filas. -->
              <div *ngIf="t.open" class="flex flex-col gap-1 p-3">
                <ng-container *ngTemplateOutlet="stopsList; context: { $implicit: t }"></ng-container>
              </div>
            </div>
          </ng-container>

          <!-- MODO GRID: el mosaico de rutas a la izquierda, las paradas de la
             seleccionada a la derecha. Dos ejes en vez de uno: con 16 rutas,
             elegir cual mirar cuesta hoy el mismo scroll que leerla, porque la
             eleccion y la lectura comparten el eje vertical.
             Las paradas son el MISMO `#stopsList` del modo lista: un solo markup
             renderizado en dos lugares, porque dos copias divergen a la primera
             correccion (el mismo criterio por el que `#ordersDetail` es template). -->
          <!-- TRES columnas y no dos: el divisor es una columna propia en vez de un
             elemento posicionado sobre el `gap`, asi el layout lo tiene en cuenta y
             no hay que sincronizar un `left` con un ancho.
             El ancho del mosaico sale de `--grid-tiles-w`, que el arrastre escribe
             desde FUERA de la zona de Angular. El binding de abajo lo deja aplicado
             despues de soltar y al restaurar la foto; `null` cae al `22rem`. -->
          <div *ngIf="viewMode === 'grid'" [style.--grid-tiles-w]="gridTilesWidthCss"
            class="grid gap-4 lg:grid-cols-[var(--grid-tiles-w,22rem)_auto_minmax(0,1fr)]">

            <!-- El mosaico. Cada tile lleva SOLO lo que sirve para elegirlo: el color
               que lo empareja con su tag y sus pines, el nombre que lo identifica, el
               territorio que lo desambigua —ruta y territorio comparten numero—, la
               capacidad que dice si esta llena y las paradas que dicen cuanto trabajo
               es. Los otros doce datos del encabezado de la tarjeta contestan "que
               tiene adentro", que es la pregunta de DESPUES de elegir: van al panel. -->
            <!-- `auto-fill` y no puntos de corte de ventana: las columnas se cuentan
               contra el ancho del PROPIO mosaico. Con `sm:/lg:/xl:grid-cols-N`,
               arrastrar el mosaico a su minimo en un monitor ancho lo dejaba creyendo
               que tenia dos columnas, y el texto se aplastaba justo cuando el usuario
               pidio menos espacio. Ademas reflowea DURANTE el arrastre, porque el
               navegador ya esta recalculando el layout de todas formas. -->
            <div class="grid content-start gap-2 grid-cols-[repeat(auto-fill,minmax(10rem,1fr))]">
              <!-- Envuelto en un `div` para que el icono del mapa no quede DENTRO del
                 boton del tile: un boton dentro de otro no es html valido y el clic
                 queda ambiguo. El icono va posicionado en la esquina. -->
              <div *ngFor="let t of visibleTrucksOf(op)" class="relative">
              <button type="button" (click)="selectTruck(t)"
                [attr.aria-pressed]="isTruckSelected(op, t)"
                [title]="t.subRouteName + ' · ' + t.stops.length + ' paradas'"
                class="flex h-full w-full flex-col gap-1.5 rounded-xl border border-slate-100 border-l-4 bg-white p-3 pr-9 text-left shadow-sm transition-shadow hover:shadow-md"
                [style.border-left-color]="t.color" [class.ring-2]="isTruckSelected(op, t)"
                [class.ring-indigo-400]="isTruckSelected(op, t)">
                <span class="truncate text-xs font-bold text-slate-900">{{ t.subRouteName }}</span>
                <span *ngIf="t.territoryName"
                  class="w-fit truncate rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
                  Territorio {{ t.territoryName }}
                </span>
                <div class="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
                  <div class="h-full rounded-full transition-all" [style.width.%]="t.capacityPct"
                    [style.background-color]="t.capacityPct > 90 ? '#f43f5e' : t.color"></div>
                </div>
                <span class="flex items-baseline justify-between gap-2 text-[11px] text-slate-500">
                  <span>{{ t.stops.length }} paradas</span>
                  <!-- El PESO y no solo el porcentaje: `93%` dice que proporcion del
                     camion se usa, no cuanto sube. Para decidir si entra un pedido
                     mas hace falta el numero. -->
                  <span class="font-semibold text-slate-700">
                    {{ t.weightLb | number: '1.0-0' }} lb · {{ t.capacityPct | number: '1.0-0' }}%
                  </span>
                </span>
                <span class="text-[11px] text-slate-500">
                  <ng-container
                    *ngTemplateOutlet="routeWindow; context: { $implicit: t, compact: true }"></ng-container>
                </span>
                <!-- Con filtro activo, cuantas de sus paradas coinciden. El tile sigue
                   declarando sus totales REALES, igual que la tarjeta: los totales de
                   un subconjunto describirian un recorrido que el camion no hace. -->
                <span *ngIf="searchActive"
                  class="w-fit rounded-full bg-indigo-50 px-2 py-0.5 text-[10px] font-bold text-indigo-600">
                  {{ truckHits(t) }} de {{ t.stops.length }} coinciden
                </span>
              </button>
              <!-- El icono del mapa, en la esquina y FUERA del boton del tile. Con la
                 capa superpuesta no cambia la seleccion del mosaico ni saca al usuario
                 de aca: es una consulta. -->
              <button mat-icon-button type="button" class="!absolute right-0 top-0 z-10"
                (click)="openRouteOnMap(t.truckId, t.subRouteName)"
                title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:map"></mat-icon>
              </button>
              </div>

              <!-- El filtro puede dejar el mosaico vacio. Decirlo, en vez de un hueco:
                 un mosaico en blanco se lee como que la corrida no produjo rutas. -->
              <div *ngIf="!visibleTrucksOf(op).length"
                class="rounded-xl border border-dashed border-slate-200 p-4 text-xs text-slate-500">
                Ninguna ruta tiene paradas que coincidan con el filtro.
              </div>
            </div>

            <!-- EL DIVISOR. `hidden lg:flex` porque abajo de `lg` los dos contenedores
               se apilan: no hay nada que dividir, y un control sin efecto es peor que
               ninguno — el mismo criterio que el selector de modo con el mapa abierto.
               `touch-none` para que el navegador no se quede el gesto como scroll.
               `role="separator"` con sus flechas: un divisor que solo responde al
               arrastre es inutilizable sin mouse. -->
            <div class="hidden lg:flex lg:items-center lg:justify-center" role="separator" aria-orientation="vertical"
              tabindex="0" aria-label="Ancho del mosaico de rutas" [attr.aria-valuenow]="tilesWidthAria"
              [attr.aria-valuemin]="tilesWidthMin" title="Arrastrar para cambiar el ancho · flechas para ajustar"
              (pointerdown)="startTilesResize($event)" (keydown.ArrowLeft)="nudgeTilesWidth($event, -16)"
              (keydown.ArrowRight)="nudgeTilesWidth($event, 16)">
              <div class="group flex h-full w-3 cursor-col-resize touch-none items-center justify-center">
                <span class="h-16 w-1 rounded-full bg-slate-200 transition-colors group-hover:bg-indigo-400"></span>
              </div>
            </div>

            <!-- El panel de la ruta seleccionada. `selectedTruckOf` DERIVA cual es: si
               la elegida quedo fuera del filtro, cae a la primera visible, porque el
               panel no puede mostrar una ruta que no esta en el mosaico. -->
            <div *ngIf="selectedTruckOf(op) as t"
              class="overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm">
              <div class="flex flex-col gap-1.5 border-l-4 p-4" [style.border-left-color]="t.color">
                <div class="flex flex-wrap items-center gap-2">
                  <!-- El mapa de la ruta que el panel esta mostrando. El tile del
                     mosaico no lo lleva porque el tile ES un boton: anidar otro no es
                     html valido y el clic quedaria ambiguo. -->
                  <button mat-icon-button type="button" (click)="openRouteOnMap(t.truckId)"
                    title="Ver esta ruta en el mapa" aria-label="Ver esta ruta en el mapa">
                    <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:map"></mat-icon>
                  </button>
                  <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl"
                    [style.background-color]="t.color">
                    <mat-icon class="icon-size-5 text-white" svgIcon="heroicons_solid:truck"></mat-icon>
                  </span>
                  <span class="text-sm font-bold text-slate-900">{{ t.subRouteName }}</span>
                  <span *ngIf="t.trips > 1"
                    class="rounded-full bg-violet-50 px-2 py-0.5 text-[10px] font-bold text-violet-600">
                    {{ t.trips }} viajes
                  </span>
                  <span *ngIf="resultFor(t) as r" [title]="r.error || ''" [class]="r.status === 'ok'
                    ? 'rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-600'
                    : 'rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-bold text-rose-600'">
                    {{ r.status === 'ok' ? (r.created ? '✓ Viaje creado' : '✓ Confirmada') : '✗ Error al confirmar' }}
                  </span>
                  <span *ngIf="searchActive"
                    class="ml-auto rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-bold text-indigo-600">
                    {{ truckHits(t) }} de {{ t.stops.length }} paradas coinciden
                  </span>
                </div>
                <div class="text-secondary flex flex-wrap items-center gap-1.5 text-xs">
                  <span *ngIf="t.territoryName"
                    class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">
                    Territorio {{ t.territoryName }}
                  </span>
                  <span>{{ t.vehicleLabel }}</span>
                  <span *ngIf="t.driver">· {{ t.driver }}</span>
                </div>
                <div class="text-secondary flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-medium">
                  <ng-container *ngTemplateOutlet="truckMetaRow; context: { $implicit: t }"></ng-container>
                </div>
                <!-- La misma barra de capacidad de la tarjeta, con el mismo criterio: mide
                   el VIAJE mas cargado, no el total del dia. Con recargas el camion
                   descarga y vuelve a llenarse, asi que sumar los viajes daria un
                   porcentaje que no significa nada. -->
                <div class="mt-1">
                  <div class="flex items-center justify-between text-xs">
                    <span class="text-secondary font-medium">
                      Capacidad{{ t.trips > 1 ? ' (viaje más cargado)' : '' }}
                    </span>
                    <span class="font-semibold text-slate-700">
                      {{ t.heaviestTripLb | number: '1.0-0' }} / {{ t.capacityLb | number: '1.0-0' }} lb
                      <span class="text-secondary font-normal">
                        (~{{ t.heaviestTripKg | number: '1.0-0' }} / {{ t.capacityKg | number: '1.0-0' }} kg)
                      </span>
                      · {{ t.capacityPct | number: '1.0-0' }}%
                      <span *ngIf="t.trips > 1" class="text-secondary font-normal">
                        · total del día: {{ t.weightLb | number: '1.0-0' }} lb
                      </span>
                    </span>
                  </div>
                  <div class="mt-1 h-2 w-full overflow-hidden rounded-full bg-slate-100">
                    <div class="h-full rounded-full transition-all" [style.width.%]="t.capacityPct"
                      [style.background-color]="t.capacityPct > 90 ? '#f43f5e' : t.color"></div>
                  </div>
                </div>
              </div>

              <!-- Las paradas: lista colapsable, igual que en modo lista. Lo que el modo
                 grid cambia es como se elige la RUTA, no como se leen sus datos. Sin
                 `t.open`: el panel muestra UNA ruta de dieciseis, asi que construirla
                 no es el costo que el colapso de la tarjeta venia a evitar. -->
              <div class="flex flex-col gap-1 p-3">
                <ng-container *ngTemplateOutlet="stopsList; context: { $implicit: t }"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mapa -->
      <div *ngIf="activeTab === 'map'" class="flex min-h-0 flex-1 flex-col gap-3">
        <!-- Selector: una ruta a la vez. Con 16 rutas y 226 pines simultáneos el
           mapa era ilegible, y la paleta de 7 colores repite cada 7 rutas. -->
        <div *ngIf="!mapExpanded" class="flex flex-wrap items-center gap-3">
          <mat-form-field appearance="fill" class="w-72" subscriptSizing="dynamic">
            <mat-label>Ruta a mostrar</mat-label>
            <mat-select [ngModel]="selectedTruckId" (ngModelChange)="selectMapRoute($event)">
              <mat-option [value]="null">Todas las rutas</mat-option>
              <mat-option *ngFor="let o of routeOptions" [value]="o.truckId">
                {{ o.label }} ({{ o.stops }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <span class="flex items-center gap-1.5 text-xs font-bold text-slate-900">
            <span class="h-3 w-3 rounded-sm" [style.background-color]="warehouseColor"></span>
            Almacén
          </span>
          <span *ngIf="selectedTruckId" class="text-secondary text-xs">
            Mostrando <b>{{ selectedRouteLabel }}</b> con su recorrido real.
          </span>
          <span *ngIf="!selectedTruckId" class="text-secondary text-xs">
            Todas las rutas: se muestran las paradas, sin dibujar recorridos.
          </span>

          <span class="ml-auto flex items-center gap-2">
            <button mat-stroked-button type="button" (click)="refitMap()"
              title="Volver a encuadrar todas las paradas de la selección">
              <mat-icon svgIcon="heroicons_outline:viewfinder-circle"></mat-icon>
              Re-encuadrar
            </button>
            <button mat-stroked-button type="button" (click)="toggleMapExpanded()"
              title="El mapa ocupa el diálogo completo. Escape lo restaura.">
              <mat-icon svgIcon="heroicons_outline:arrows-pointing-out"></mat-icon>
              Expandir
            </button>
          </span>
        </div>

        <!-- Crece con el diálogo, con un piso ALTO (60vh): el mapa es la razón de la
           pestaña, y con el piso anterior de 24rem salía como una franja que había
           que expandir siempre. Si la cadena de flex se rompe, un mapa de 0 px es
           un fallo peor que dejar espacio en blanco.
           Expandido: cubre el diálogo entero (`fixed inset-0` dentro del contexto
           del contenedor del diálogo). Leaflet no detecta el cambio de tamaño: el
           toggle llama `resize()` después del repaint. -->
        <div class="overflow-hidden" [ngClass]="mapExpanded
          ? 'fixed inset-0 z-[1090] bg-white'
          : 'relative min-h-[60vh] flex-1 rounded-2xl border border-slate-100 shadow-sm'">
          <!-- Barra flotante del modo expandido: cambiar de ruta es el gesto más
             frecuente del mapa; esconder el selector obligaría a restaurar para
             cada cambio. z sobre los controles de Leaflet (1000). -->
          <div *ngIf="mapExpanded"
            class="absolute left-3 right-3 top-3 z-[1100] flex flex-wrap items-center gap-2 rounded-xl bg-white/95 p-2 shadow-md ring-1 ring-slate-200">
            <mat-form-field appearance="fill" class="w-64" subscriptSizing="dynamic">
              <mat-label>Ruta a mostrar</mat-label>
              <mat-select [ngModel]="selectedTruckId" (ngModelChange)="selectMapRoute($event)">
                <mat-option [value]="null">Todas las rutas</mat-option>
                <mat-option *ngFor="let o of routeOptions" [value]="o.truckId">
                  {{ o.label }} ({{ o.stops }})
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-stroked-button type="button" (click)="refitMap()"
              title="Volver a encuadrar todas las paradas de la selección">
              <mat-icon svgIcon="heroicons_outline:viewfinder-circle"></mat-icon>
              Re-encuadrar
            </button>
            <button mat-stroked-button type="button" class="ml-auto" (click)="toggleMapExpanded()"
              title="También con Escape">
              <mat-icon svgIcon="heroicons_outline:arrows-pointing-in"></mat-icon>
              Restaurar
            </button>
          </div>
          <!-- Recreado por selección (containerId único): el GeoManager solo AGREGA
             marcadores, así que sin recrearlo se apilarían los de la ruta anterior. -->
          <!-- Solo si la capa esta cerrada: `@ViewChild(GeoManagerComponent)` toma el
             PRIMERO del template, asi que con dos mapas a la vez `refitMap()` y el
             modo expandido operarian sobre el que no es. Y la capa es `fixed inset-0`:
             el principal quedaria tapado igual, seria pagar un Leaflet invisible. -->
          <ng-container *ngIf="visibleMarkerGroups.length && !mapOverlay">
            <app-geo-manager *ngFor="let key of [mapRenderKey]; trackBy: trackByKey"
              [containerId]="'loads-optimization-map-' + key" [markerGroups]="visibleMarkerGroups"
              [polylines]="visiblePolylines" [zoom]="12" displayMode="tooltip" [captions]="{ title: 'Rutas sugeridas' }"
              class="block h-full w-full">
            </app-geo-manager>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- ====== Las acciones del ORDEN COMPLETO, en un lugar fijo ======
     Vivian repartidas entre siete bloques con borde apilados arriba de la primera ruta,
     intercaladas con informativos: dejaban de leerse como acciones. Y las dos globales
     tienen momentos OPUESTOS —partir del orden guardado es lo primero, reordenar lo
     ultimo—, asi que ninguna posicion dentro del flujo servia para las dos. Una barra
     fija disuelve la pregunta: esta siempre.

     Entre `mat-dialog-content` y `mat-dialog-actions`, que es el unico lugar del dialogo
     que no scrollea. Las explicaciones que acompanaban a cada boton viven en su `title`:
     siguen disponibles y dejan de ocupar. -->
<div *ngIf="reviewOpen && reviewTab === 'custom'"
  class="flex flex-col gap-2 border-t border-slate-100 bg-slate-50 !px-6 !py-3">
  <!-- El RECIBO de la accion, no un informativo: existe solo despues de accionar y vive
     junto al boton que lo produjo. Una accion que toca varias rutas sin recibo no se
     puede revisar. -->
          <div *ngIf="savedOrderApplyResult as res"
            class="flex flex-col gap-0.5 rounded-lg bg-slate-50 px-3 py-2 text-[11px] text-slate-700">
            <!-- Lo que VOLVIO a su ruta: es el resultado nuevo, y va primero porque es
               el que puede haber deshecho trabajo manual. -->
            <span *ngIf="res.reclaimedStops" class="font-semibold">
              {{ res.reclaimedStops }}
              {{ res.reclaimedStops === 1 ? 'parada volvió' : 'paradas volvieron' }} a su ruta
              guardada.
            </span>
            <span *ngIf="res.applied" class="font-semibold">
              Se reordenaron {{ res.applied }}
              {{ res.applied === 1 ? 'ruta' : 'rutas' }}<ng-container *ngIf="res.matched">
                · {{ res.matched }} ya coincidían</ng-container>.
            </span>
            <!-- "No hubo nada que aplicar" SOLO cuando de verdad no hubo nada: sin
               reordenamientos, sin paradas devueltas, y sin nada pendiente. Antes esta
               linea convivia con "falta 1 parada guardada" dos renglones mas abajo. -->
            <span
              *ngIf="!res.applied && !res.reclaimedStops && !res.blockedStops && !res.conflictedDestinations"
              class="font-semibold">
              No hubo nada que aplicar: {{ res.matched }}
              {{ res.matched === 1 ? 'ruta ya coincidía' : 'rutas ya coincidían' }} con el
              orden guardado.
            </span>
            <!-- Bloqueadas por territorio. Se declara QUE HACER: el problema esta en el
               maestro, no en el plan ni en el viaje. -->
            <span *ngIf="res.blockedStops" class="text-amber-700">
              {{ res.blockedStops }}
              {{ res.blockedStops === 1 ? 'parada no pudo volver' : 'paradas no pudieron volver' }}:
              su ruta guardada ya no visita el territorio del cliente. Hay que revisar el
              maestro de la ruta.
            </span>
            <!-- Dos viajes reclaman el mismo destino: no se elige a dedo. -->
            <span *ngIf="res.conflictedDestinations" class="text-amber-700">
              {{ res.conflictedDestinations }}
              {{ res.conflictedDestinations === 1 ? 'destino está' : 'destinos están' }} en el
              orden guardado de <b>dos rutas</b>: se dejaron donde estaban, porque elegir uno
              de los dos viajes no tiene base.
            </span>
            <!-- Y este es el UNICO caso en que "ya no esta en el plan" es cierto. -->
            <span *ngIf="res.goneDestinations" class="text-slate-500">
              {{ res.goneDestinations }}
              {{ res.goneDestinations === 1 ? 'destino guardado ya no está' : 'destinos guardados ya no están' }}
              en el día: no hay nada que restaurar de {{ res.goneDestinations === 1 ? 'él' : 'ellos' }}.
            </span>
            <span class="text-slate-500">
              Los pedidos que no estaban en el orden guardado se quedaron donde los puso el
              optimizador.
            </span>
          </div>
  <!-- Las acciones de LA RUTA SELECCIONADA, solo en mosaico.
     Solo ahi porque solo ahi el objeto esta A LA VISTA: la selecciona el tile, vive en
     `reviewGridRouteId` y el panel la muestra. En tarjetas nadie la escribe y
     `selectedReviewRouteOf()` cae a `visible[0]`, asi que un boton que dijera
     "Reordenar ENTREGA 303" apuntaria a una ruta que el operador nunca eligio — y las
     tres reemplazan el orden manual, pueden dejar paradas afuera o tiran las ediciones.
     Las globales fueron seguras de mover porque su objeto es "todo".

     Arriba de la fila global: puntual -> total -> Confirmar. Y `Reordenar` queda a un
     renglon de `Reordenar N rutas`, asi que la diferencia de alcance se lee en vez de
     deducirse. -->
  <div *ngIf="viewMode === 'grid'" class="flex flex-wrap items-center gap-2">
    <span class="text-xs font-bold text-slate-700">
      {{ selectedReviewRouteOf()?.label || 'Sin ruta seleccionada' }}
    </span>
    <ng-container *ngIf="selectedReviewRouteOf() as sel">
      <button mat-stroked-button type="button"
        [disabled]="!!routeRecalcBlockedReason(sel) || recalcStateOf(sel) === 'running'"
        (click)="recalcReviewRoute(sel)"
        [title]="routeRecalcBlockedReason(sel) || 'Le pide al optimizador el recorrido de las paradas que esta ruta tiene ahora. El optimizador reordena: tu orden manual se reemplaza.'">
        <mat-spinner *ngIf="recalcStateOf(sel) === 'running'" diameter="16"
          class="mr-2 inline-block"></mat-spinner>
        <mat-icon *ngIf="recalcStateOf(sel) !== 'running'" svgIcon="heroicons_outline:clock"></mat-icon>
        Reordenar
      </button>
      <button mat-stroked-button type="button"
        [disabled]="!!routeRecalcBlockedReason(sel) || recalcStateOf(sel) === 'running'"
        (click)="replanReviewRoute(sel)"
        [title]="routeRecalcBlockedReason(sel) || 'Replanifica esta ruta con SU camión y SU turno: horas y trayecto exactos, con las recargas modeladas. Puede devolverte pedidos que no entren.'">
        <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
        Replanificar
      </button>
      <button mat-stroked-button type="button" [disabled]="!!routeUndoBlockedReason(sel)"
        (click)="resetReview(sel)" [title]="routeUndoBlockedReason(sel) || 'Devuelve esta ruta al orden que propuso el optimizador, y con él sus paradas.'">
        <mat-icon svgIcon="heroicons_outline:arrow-uturn-left"></mat-icon>
        Deshacer cambios
      </button>
    </ng-container>
  </div>
  <div class="flex flex-wrap items-center justify-end gap-2">
    <!-- Ir a donde cayo el ultimo pedido que cruzo de ruta. En el mosaico el panel
       muestra UNA ruta, asi que un pedido que cruza sale de la vista: se ve
       desaparecer una fila y nada mas. El parrafo que lo explicaba se retiro; el
       control se queda, que es lo que resuelve el problema. -->
    <button *ngIf="lastReviewMove as mv" mat-stroked-button type="button"
      (click)="goToLastReviewMove()"
      [title]="'El ultimo pedido que moviste, ' + mv.name + ', paso a ' + mv.toLabel + '. Ir a esa ruta.'">
      <mat-icon svgIcon="heroicons_outline:arrow-right-circle"></mat-icon>
      Ver esa ruta
    </button>
    <button *ngIf="canApplySavedOrder" mat-stroked-button type="button"
      (click)="applySavedVisitOrder()" title="Hay un orden de visita guardado para el viaje de hoy. Cada pedido vuelve a su ruta guardada y a su posición. Si moviste pedidos entre rutas a mano, eso se deshace.">
      <mat-icon svgIcon="heroicons_outline:arrow-down-on-square"></mat-icon>
      Partir del orden guardado
    </button>
    <!-- MISMO verbo que el boton de cada ruta: `recalcEditedRoutes()` llama en bucle a
       `recalcReviewRoute(r)`, que es lo que hace "Reordenar". Dos nombres obligaban a
       descubrir que era la misma accion. -->
    <button *ngIf="reviewRoutesToRecalc.length" mat-stroked-button type="button"
      [disabled]="isRecalculating" (click)="recalcEditedRoutes()" title="Le pide al optimizador el recorrido de las paradas que esas rutas tienen ahora: trae horas de llegada, totales y trayecto. El optimizador reordena, así que el orden manual de esas rutas se reemplaza. Para saber qué cabe en cada camión, cada ruta tiene su botón Replanificar.">
      <mat-spinner *ngIf="isRecalculating" diameter="18" class="mr-2 inline-block"></mat-spinner>
      <mat-icon *ngIf="!isRecalculating" svgIcon="heroicons_outline:clock"></mat-icon>
      Reordenar {{ reviewRoutesToRecalc.length }}
      {{ reviewRoutesToRecalc.length === 1 ? 'ruta' : 'rutas' }}
    </button>
    <button *ngIf="reviewRoutes.length" mat-stroked-button type="button"
      aria-label="Descargar las rutas en JSON" (click)="downloadReviewExport()" title="Descarga las rutas con coordenadas y la secuencia vigente, para comparar contra otro optimizador. Las rutas con orden editado salen sin los tiempos del optimizador: no calculó esa secuencia.">
      <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
      Descargar JSON
    </button>
  </div>
</div>

<div mat-dialog-actions class="flex justify-end gap-3 border-t border-slate-100 !px-6 !py-4">
  <button *ngIf="!reviewOpen" mat-stroked-button (click)="close()">Cerrar</button>

  <!-- Paso 1: la acción principal es lanzar la corrida. -->
  <ng-container *ngIf="state === 'select'">
    <button mat-flat-button color="primary" [disabled]="!canGenerate" (click)="run()">
      <mat-icon svgIcon="heroicons_outline:sparkles"></mat-icon>
      Generar sugerencia
    </button>
  </ng-container>

  <!-- Ya corrió: se puede cambiar el alcance o repetir con el mismo. -->
  <ng-container *ngIf="state !== 'select' && state !== 'loading' && state !== 'optimizing' && !reviewOpen">
    <button mat-stroked-button (click)="backToSelection()" [disabled]="isRunningGroups">
      <mat-icon svgIcon="heroicons_outline:building-office-2"></mat-icon>
      Cambiar oficinas
    </button>
    <button mat-flat-button color="primary" (click)="run()" [disabled]="!canGenerate || isRunningGroups">
      <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
      Volver a calcular
    </button>
  </ng-container>

  <!-- Abrir el gestor: revisar el orden ES la confirmación consciente. -->
  <ng-container *ngIf="state === 'result' && !reviewOpen">
    <button mat-flat-button color="primary" (click)="confirm()" [disabled]="!canConfirm"
      matTooltip="Revisa el orden de visita antes de crear o asignar el viaje de cada subruta.">
      <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
      Confirmar
    </button>
  </ng-container>

  <!-- El gestor abierto: confirmar de verdad, con el orden vigente. -->
  <ng-container *ngIf="state === 'result' && reviewOpen">
    <button mat-stroked-button type="button" (click)="closeReview()" [disabled]="confirming">
      <mat-icon svgIcon="heroicons_outline:arrow-left"></mat-icon>
      Volver
    </button>
    <button mat-flat-button color="primary" (click)="confirmFromReview()" [disabled]="confirming"
      matTooltip="Crea o asigna el viaje de cada subruta y guarda este orden de visita.">
      <mat-spinner *ngIf="confirming" diameter="18" class="mr-2 inline-block"></mat-spinner>
      <mat-icon *ngIf="!confirming" svgIcon="heroicons_outline:check-circle"></mat-icon>
      Confirmar {{ reviewRoutes.length }} rutas
      <ng-container *ngIf="reviewCustomCount"> ({{ reviewCustomCount }} personalizadas</ng-container>
      <!-- Los añadidos van EN el boton y no solo en el aviso: es lo que se esta por
         persistir, y es lo unico del gestor que no salio de ningun plan. -->
      <ng-container *ngIf="reviewCustomCount && reviewInjectedCount">, {{ reviewInjectedCount }}
        {{ reviewInjectedCount === 1 ? 'pedido añadido' : 'pedidos añadidos' }}</ng-container>
      <ng-container *ngIf="reviewCustomCount">)</ng-container>
    </button>
  </ng-container>
</div>

<!-- El mapa de UNA ruta, superpuesto. Reusa el patron del modo expandido:
     `fixed inset-0 z-[1090]` con una barra flotante en `z-[1100]` —por encima de los
     controles de Leaflet, que estan en 1000—.
     Superpuesto y no navegando porque ver el mapa de una ruta es una CONSULTA: no
     cambia de pestana, no cierra el gestor y no toca la seleccion del mapa principal.
     Al cerrar, el dialogo queda exactamente como estaba. -->
<div *ngIf="mapOverlay as ov" class="fixed inset-0 z-[1090] overflow-hidden bg-white">
  <div
    class="absolute left-3 right-3 top-3 z-[1100] flex flex-wrap items-center gap-2 rounded-xl bg-white/95 p-2 shadow-md ring-1 ring-slate-200">
    <span class="flex items-center gap-2 text-sm font-bold text-slate-900">
      <mat-icon class="icon-size-5 text-slate-400" svgIcon="heroicons_outline:map"></mat-icon>
      {{ ov.label }}
    </span>
    <!-- Con orden editado el trayecto NO se dibuja, y hay que decir por que: un mapa
       se lee como mas autoritativo que un numero, y un mapa sin linea sin explicacion
       parece un error del motor. `evaluate-route` evalua una secuencia dada pero
       devuelve tiempo y distancia, no geometria. -->
    <span *ngIf="ov.edited"
      class="flex items-center gap-1.5 rounded-lg bg-violet-50 px-2 py-1 text-xs text-violet-700">
      <mat-icon class="icon-size-4 shrink-0" svgIcon="heroicons_outline:bars-3"></mat-icon>
      <span>
        Tu <b>orden personalizado</b>: los pines están numerados como los dejaste.
        <b>Sin recorrido</b>, porque el trayecto por calle solo se puede calcular para el orden
        del optimizador.
      </span>
    </span>
    <span *ngIf="!ov.edited" class="text-secondary text-xs">Con su recorrido real.</span>
    <span class="ml-auto flex items-center gap-2">
      <button mat-stroked-button type="button" (click)="refitMap()"
        title="Volver a encuadrar todas las paradas">
        <mat-icon svgIcon="heroicons_outline:viewfinder-circle"></mat-icon>
        Re-encuadrar
      </button>
      <button mat-flat-button color="primary" type="button" (click)="closeMapOverlay()"
        title="También con Escape">
        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
        Cerrar mapa
      </button>
    </span>
  </div>
  <!-- Recreado por ruta (containerId unico): el GeoManager solo AGREGA marcadores,
     asi que sin recrearlo se apilarian los de la ruta anterior. -->
  <ng-container *ngIf="overlayMarkerGroups.length">
    <app-geo-manager *ngFor="let key of [overlayRenderKey]; trackBy: trackByKey"
      [containerId]="'loads-optimization-route-map-' + key" [markerGroups]="overlayMarkerGroups"
      [polylines]="overlayPolylines" [zoom]="12" displayMode="tooltip"
      [captions]="{ title: ov.label }" class="block h-full w-full"></app-geo-manager>
  </ng-container>
  <div *ngIf="!overlayMarkerGroups.length"
    class="flex h-full items-center justify-center px-6 text-sm text-slate-500">
    Esta ruta no tiene paradas con geolocalización usable, así que no hay nada que ubicar en el
    mapa.
  </div>
</div>

<!-- Detalle de materiales de un pedido, compartido por las listas que NO son
     paradas planificadas (no asignados y excluidos).
     Un `ng-template` y no una copia por lista: es la misma pregunta ("que lleva
     este pedido") respondida con los mismos datos, y dos copias divergen a la
     primera correccion. Lo que NO comparte es el costo de tiempo de la visita:
     un pedido que no entro no tiene llegada ni atencion que mostrar. -->
<ng-template #ordersDetail let-detail>
  <div *ngIf="detail.split" class="flex items-start gap-2 rounded-lg border border-amber-100 bg-amber-50 px-3 py-2">
    <mat-icon class="icon-size-4 shrink-0 text-amber-500" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
    <span class="text-xs text-amber-900">
      Esta visita esta <b>dividida por capacidad</b>: el detalle corresponde al cliente
      completo, no solo a esta parte.
    </span>
  </div>

  <div *ngIf="!detail.orders.length" class="text-xs text-slate-500">
    No se encontraron los pedidos de este cliente.
  </div>

  <div *ngFor="let o of detail.orders" class="flex flex-col gap-1">
    <div class="flex items-baseline justify-between gap-3 px-1">
      <span class="text-xs font-bold text-slate-700">Pedido {{ o.serial }}</span>
      <span class="text-xs font-medium text-slate-500">{{ o.weightLb | number: '1.0-1' }} lb</span>
    </div>
    <app-order-details-table *ngIf="o.detail.length; else noPointMaterials" [detailData]="o.detail"
      [UMPActive]="data.UMPActive ?? false"></app-order-details-table>
    <ng-template #noPointMaterials>
      <span class="px-1 text-xs text-slate-400">Sin materiales en el pedido.</span>
    </ng-template>
  </div>
</ng-template>


<!-- La lista de paradas de UNA ruta: salida del almacen, las paradas agrupadas por
     viaje con su recarga, el detalle colapsable de cada una, y el regreso.
     Un `ng-template` y no una copia por modo: son ~160 lineas de markup y dos
     copias divergen a la primera correccion. Mismo criterio que `#ordersDetail`.
     `let-t` es la ruta (`TruckRouteView`); el indice `i` del *ngFor sigue siendo
     el que `stopCostOf(s, i)` necesita para el costo de tiempo de la visita. -->
<!-- Las insignias de TIEMPO de una ruta y sus acciones de recalculo.
     Compartidas por la tarjeta del modo lista y el panel del mosaico. Vivian solo
     en la tarjeta, asi que en modo grid —que es el DEFECTO— no se veia el recorrido
     recalculado, ni la jornada estimada, ni el estado… y no habia como recalcular.
     Al nivel raiz por lo mismo que las piezas de parada: una `#ref` dentro de un
     `*ngIf` no existe fuera de el. -->
<ng-template #routeTimeBadges let-r>
<!-- Con que se armo la ruta, tambien en el gestor: es la misma pregunta y tiene que
     tener la misma respuesta. Montado en la pieza compartida, llega a la tarjeta y al
     panel del mosaico. -->
<ng-container *ngTemplateOutlet="routeParamsControl; context: { $implicit: r }"></ng-container>
<!-- La ventana del dia, primero: es lo que se busca de un vistazo. Sale del MISMO
     resolvedor que los tiempos de la ruta, asi que hereda su estado —plan, recalculo
     o estimado— sin una rama nueva. -->
<span class="text-secondary text-[11px]">
  <ng-container
    *ngTemplateOutlet="routeWindow; context: { $implicit: reviewTimelineOf(r) }"></ng-container>
</span>
<!-- Los números del recorrido REAL de esta ruta, cuando el motor ya
   evaluó su secuencia vigente. Se distinguen de los del plan: describen
   otro conjunto de paradas. -->
<ng-container *ngIf="recalcOf(r) as rc">
  <span
    class="rounded-full bg-sky-50 px-2 py-0.5 text-[10px] font-bold text-sky-700"
    [title]="'Recorrido calculado por el optimizador para la secuencia vigente de esta ruta. No son los números del plan: el plan ordenó otro conjunto de paradas.'">
    {{ rc.totalDistanceKm | number: '1.0-1' }} km ·
    {{ rc.totalDurationMin | number: '1.0-0' }} min · termina {{ rc.endTime }}
  </span>
  <!-- Pasarse NO bloquea: el operador ya decidió cambiar la ruta. -->
  <span *ngIf="recalcExceedsMin(r) as over"
    class="rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-bold text-rose-600"
    [title]="'La jornada recalculada termina después del fin del turno. Se declara, no impide confirmar.'">
    ⚠ {{ over }} min pasado el turno
  </span>
  <!-- `/sort` no modela el regreso a recargar: el número es un PISO.
     Con `plan` las recargas SÍ están modeladas, así que el mismo aviso
     ahí sería falso — y un aviso falso enseña a ignorar los demás. -->
  <span *ngIf="rc.multiTrip && rc.source === 'sort'"
    class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold text-slate-500"
    title="Esta ruta hace más de un viaje y se reordenó: el resultado no modela el regreso al almacén a recargar, así que el tiempo es un mínimo. Replanificar sí lo modela.">
    tiempo mínimo · {{ r.trips }} viajes
  </span>
  <!-- De cuál de las dos preguntas salió: sus límites no son los mismos. -->
  <span class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-500"
    [title]="rc.source === 'plan'
      ? 'Replanificado con el camión y el turno de esta ruta: capacidad, ventanas y recargas incluidas.'
      : 'Reordenado: el mejor recorrido para TODAS sus paradas, sin mirar capacidad ni turno.'">
    {{ rc.source === 'plan' ? 'replanificada' : 'reordenada' }}
  </span>
  <!-- Lo que el camión no pudo llevar. Se queda en la ruta, al final. -->
  <span *ngIf="unplacedCountOf(r) as fuera"
    class="rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700"
    title="El optimizador no pudo ubicarlas en este camión. Siguen en la ruta, al final y sin tiempos: sacarlas o moverlas es tu decisión.">
    {{ fuera }} sin ubicar
  </span>
</ng-container>
<!-- La jornada ESTIMADA. Aparece SOLO donde no hay tiempos ciertos —la
   puerta es `reviewTimelineOf`— asi que nunca convive con un numero
   del motor: serian dos respuestas a la misma pregunta y habria que
   elegir a cual creerle.
   El simbolo va PEGADO al numero, no en el tooltip: lo que distingue
   una estimacion de un calculo tiene que leerse sin pasar el mouse. -->
<ng-container *ngIf="estimatedDayOf(r) as est">
  <span class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold text-slate-600"
    [title]="'Estimacion geometrica: ' + est.travelMin + ' min de viaje + ' + est.serviceMin +
      ' min de atencion. El costo por kilometro sale de esta misma corrida (lo que el optimizador midio en sus rutas), pero en linea recta: no conoce calles, ventanas horarias ni recargas. Recalcular da el numero real.'">
    ≈ {{ formatDuration(est.totalMin) }} de jornada
  </span>
  <span *ngIf="estimatedExceedsMin(est) as over"
    class="rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700"
    title="La jornada estimada supera la duracion del turno. Es una estimacion: recalcular da el numero real.">
    ≈ se pasa {{ over }} min del turno
  </span>
  <!-- Mismo limite que `Reordenar`: el regreso a recargar no esta
     modelado, asi que el numero es un piso. -->
  <span *ngIf="r.trips > 1"
    class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold text-slate-500"
    title="Esta ruta hace mas de un viaje. La estimacion no modela el regreso al almacen a recargar, asi que el tiempo es un minimo.">
    tiempo mínimo · {{ r.trips }} viajes
  </span>
</ng-container>
<span *ngIf="recalcStateOf(r) === 'stale'"
  class="rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-bold text-amber-700"
  title="Moviste paradas después de recalcular: esos tiempos describían otra secuencia y se retiraron.">
  tiempos desactualizados
</span>
<span *ngIf="recalcErrorOf(r) as err"
  class="rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-bold text-rose-600"
  [title]="err">
  no se pudo recalcular
</span>
</ng-template>

<ng-template #routeRecalcActions let-r>
<!-- Recalcular ESTA ruta. `stopPropagation` por lo mismo que Restaurar:
   el encabezado entero colapsa la tarjeta. -->
<button *ngIf="reviewTab === 'custom' && canRecalcReviewRoute(r)" mat-stroked-button
  type="button" [disabled]="recalcStateOf(r) === 'running'"
  (click)="$event.stopPropagation(); recalcReviewRoute(r)"
  matTooltip="Le pide al optimizador el recorrido de las paradas que esta ruta tiene ahora. El optimizador REORDENA: tu orden manual se reemplaza.">
  <mat-spinner *ngIf="recalcStateOf(r) === 'running'" diameter="16"
    class="mr-2 inline-block"></mat-spinner>
  <mat-icon *ngIf="recalcStateOf(r) !== 'running'"
    svgIcon="heroicons_outline:clock"></mat-icon>
  Reordenar
</button>
<!-- La OTRA pregunta. Dos botones y no uno porque son dos respuestas
   distintas y ninguna es la correcta en general: Reordenar respeta que
   el operador decidio que sube al camion; Replanificar dice la verdad
   sobre el camion. Elegir por el le quitaria una de las dos. -->
<button *ngIf="reviewTab === 'custom' && canRecalcReviewRoute(r)" mat-stroked-button
  type="button" [disabled]="recalcStateOf(r) === 'running'"
  (click)="$event.stopPropagation(); replanReviewRoute(r)"
  matTooltip="Replanifica esta ruta con SU camion y SU turno: horas y trayecto exactos, con las recargas modeladas. Puede devolverte pedidos que no entren.">
  <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
  Replanificar
</button>
</ng-template>

<!-- La VENTANA DEL DIA de una ruta: a que hora sale del almacen y a que hora vuelve.
     Antes solo se veia abriendo la ruta, y abrir diecisiete para saber cual vuelve
     tarde no es una vista rapida.
     Recibe `TruckRouteView` o `RouteTimeline` indistintamente: los dos declaran los
     MISMOS dos campos, asi que la forma compartida no es una conversion. Desde la
     vista del plan `estimated` llega `undefined` —falsy— y el resultado nunca se
     marca como estimacion sin que nadie tenga que decirlo.
     `compact` para los mosaicos: un tile mide 10rem y `sale … · regresa …` no entra;
     `07:35 → 17:20` son once caracteres y se lee como un rango. -->
<!-- ================= La fila de meta de una ruta del RESULTADO =================
     Las dos superficies del resultado —la tarjeta de la lista y el panel del
     mosaico— mostraban esta fila DUPLICADA palabra por palabra: solo cambiaban las
     clases del contenedor. Dos copias identicas se corrigen una sola vez y la que
     se olvida es la que se ve; ya paso con la ventana del dia. El contenedor queda
     afuera porque lo que difiere entre las dos es la disposicion, no el dato. -->
<!-- ====== Los CUERPOS de los descuentos de la cobertura ======
     Cada uno vivia como una tarjeta suelta debajo de la seccion: dos de ellas sin
     presencia cuando estaban cerradas —asi que el descuento era su unica puerta— y la
     de no ubicados con encabezado, conteo y resumen propios, o sea el mismo hecho
     contado dos veces en dos lenguajes visuales. Ahora son el panel de su descuento y
     se abren EN SU LUGAR.

     Al nivel raiz por lo mismo que el resto de las piezas: una `#ref` declarada dentro
     de un `*ngIf` solo existe mientras esa vista existe. -->
<ng-template #excludedList let-op>
          <!-- Detalle de los excluidos: nunca se descartan en silencio. -->
          <div *ngIf="op.excludedPoints.length"
            class="flex flex-col gap-2 rounded-2xl border border-amber-100 bg-amber-50 p-4">
            <div class="text-xs font-bold text-amber-800">
              Estos pedidos no llegaron al optimizador (sin geolocalización, o sin cliente/identificador):
            </div>
            <!-- Tambien accionables: son los que ni llegaron al motor, y ver que
               llevaban es lo que dice si vale la pena arreglarles la geolocalizacion. -->
            <ng-container *ngFor="let p of op.excludedPoints">
              <div [hidden]="filterActive && !pointMatches(p)"
                class="flex cursor-pointer flex-wrap items-baseline gap-2 rounded-md px-2 py-1 text-xs text-amber-900 hover:bg-amber-100"
                [class.bg-amber-100]="detailOpenIn('excluded') === p.orderId"
                (click)="toggleDetail('excluded', p.orderId)">
                <span class="font-semibold">{{ p.name }}</span>
                <span *ngIf="p.commercialName"
                  class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                  p.commercialName }}</span>
                <!-- El serial distingue dos pedidos del MISMO cliente: sin el, se
                   muestran con el mismo nombre, la misma direccion y —desde que el
                   peso es el correcto— pesos que tambien pueden coincidir. -->
                <span *ngIf="p.serial" class="shrink-0 font-mono text-[10px] text-slate-500">{{ p.serial }}</span>
                <span class="text-amber-700">{{ p.address }}</span>
                <span *ngIf="p.weightLb" class="text-amber-600">
                  · {{ p.weightLb | number: '1.0-1' }} lb
                </span>
                <mat-icon class="icon-size-4 ml-auto shrink-0 self-center text-amber-400 transition-transform"
                  [class.rotate-180]="detailOpenIn('excluded') === p.orderId"
                  svgIcon="heroicons_outline:chevron-down"></mat-icon>
              </div>
              <div *ngIf="detailOpenIn('excluded') === p.orderId && detailOrdersIn('excluded') as detail"
                class="ml-2 flex flex-col gap-3 rounded-xl border border-amber-100 bg-white p-3">
                <ng-container *ngTemplateOutlet="ordersDetail; context: { $implicit: detail }"></ng-container>
              </div>
            </ng-container>
          </div>
</ng-template>

<!-- Los DOS bloques de la brecha bajo un solo descuento: `fleetGapOpen` ya gobernaba
     los dos, y separarlos inventaria una distincion que el modelo no tiene. -->
<ng-template #fleetGapList let-op>
          <!-- BRECHA DE FLOTA, agrupada por CAUSA. Cada grupo dice qué pasa y dónde
             se arregla, una sola vez: antes la causa se repetía renglón por renglón,
             así que con cinco territorios en el mismo problema había que leer cinco
             veces el mismo texto para descubrir que compartían causa. -->
          <div *ngIf="op.fleetGaps.length"
            class="flex flex-col gap-4 rounded-2xl border border-rose-200 bg-rose-50 p-4">
            <!-- El titulo NO nombra una causa: cada grupo nombra la suya, y las causas
               no son todas la misma falta (sin vehiculo, sin ruta, sin territorio).
               Lo que si comparten es donde se arreglan: en el maestro.
               El parrafo dice QUE es el maestro en vez de nombrarlo a secas: "maestro"
               y "corrida" son terminos del modelo interno, y este bloque existe para
               que alguien que no lo conoce sepa que hacer. -->
            <div class="flex flex-col gap-1">
              <div class="text-xs font-bold text-rose-800">
                {{ fleetGapHeadlineOf(op) }}
              </div>
              <!-- REMITE, no explica. Eran cuatro oraciones: tres definian el modelo
                 —que es el maestro, que es la corrida, por que reintentar no sirve— y la
                 cuarta mandaba al lugar donde eso ya esta dicho por causa y con la
                 pantalla concreta (`CAUSES[…].action`). Un parrafo que explica en general
                 arriba de una lista que instruye en particular se lee dos veces o ninguna.

                 Lo que se pierde y ninguna otra parte dice: "volver a optimizar no los
                 mueve". Es una decision explicita, no un olvido — ver el design de
                 `gap-note-one-line`. -->
              <div class="text-[11px] leading-relaxed text-rose-700">
                En cada grupo de abajo se dice qué falta y en qué pantalla se arregla.
              </div>
            </div>

            <div *ngFor="let cause of fleetGapCausesOf(op); trackBy: trackGapCause" class="flex flex-col gap-1.5">
              <!-- La causa y su acción: qué pasa y dónde se resuelve. -->
              <div class="flex flex-wrap items-baseline gap-2">
                <span class="text-xs font-bold text-rose-900">{{ cause.reason }}</span>
                <span *ngIf="cause.action" class="text-[11px] text-rose-700">
                  · {{ cause.action }}
                </span>
                <!-- Los TRES números: cuántas fichas hay que tocar, cuánto trabajo no
                   sale, y cuánto camión hace falta. -->
                <span class="ml-auto text-[11px] font-semibold text-rose-800">
                  {{ fleetGapCountsLabel(cause) }}
                </span>
              </div>

              <div *ngFor="let gap of cause.gaps"
                class="flex flex-col gap-1 rounded-lg border border-rose-100 bg-white/60 px-2 py-1.5">
                <div class="flex flex-wrap items-baseline gap-2 text-xs">
                  <!-- La RUTA primero: si el mensaje dice que se arregla en el maestro
                     de rutas, hay que saber cuál abrir. El territorio va rotulado
                     para no leerse como una ruta. -->
                  <span *ngIf="gap.routeName" class="font-bold text-rose-900">{{ gap.routeName }}</span>
                  <span class="text-rose-700">Territorio {{ gap.territoryName }}</span>
                  <span class="ml-auto font-semibold text-rose-800">
                    {{ fleetGapCountsLabel(gap) }}
                  </span>
                </div>
                <!-- Dimensionamiento: cuánta flota haría falta. Se rotula como
                   estimación, nunca como un plan: no hay camión al que asignarle
                   estas rutas. -->
                <div *ngIf="gap.sizing as sizing"
                  class="rounded-lg border border-rose-200 bg-white px-2 py-1 text-[11px] text-rose-900">
                  <span class="font-semibold">Harían falta</span>
                  <span *ngFor="let m of sizing.mix; let last = last">
                    {{ m.used }} × {{ m.capacityLb | number: '1.0-0' }} lb{{ last ? '' : ' + ' }}
                  </span>
                  <span *ngIf="sizing.isMinimum" class="ml-1 font-semibold">
                    (mínimo: {{ sizing.unassigned }} sin entrar)
                  </span>
                  <span *ngIf="sizing.capacityAssumed" class="ml-1 italic">
                    — capacidad supuesta, la oficina no tiene camiones asignados
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Detalle pedido por pedido de la brecha, con sus materiales. -->
          <div *ngIf="op.withoutRoutePoints.length"
            class="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-4">
            <!-- "Los mismos" es la palabra que hace el trabajo: esta lista es el aplanado
               de la brecha de arriba, no otra cubeta. Sin decirlo, dos bloques seguidos
               con el mismo dato se leen como dos problemas distintos. -->
            <div class="flex flex-col gap-1">
              <div class="text-xs font-bold text-slate-700">
                {{ withoutRouteHeadlineOf(op) }}
              </div>
              <div class="text-[11px] leading-relaxed text-slate-500">
                Arriba están agrupados por ruta, para saber qué ficha abrir. Acá va cada
                pedido con su cliente, dirección y peso, para saber a qué clientes afecta:
                clic en uno para ver qué materiales llevaba.
              </div>
            </div>
            <ng-container *ngFor="let p of op.withoutRoutePoints">
              <div [hidden]="filterActive && !pointMatches(p)"
                class="flex cursor-pointer flex-wrap items-baseline gap-2 rounded-md px-2 py-1 text-xs text-slate-800 hover:bg-slate-100"
                [class.bg-slate-100]="detailOpenIn('without-route') === p.orderId"
                (click)="toggleDetail('without-route', p.orderId)">
                <span class="font-semibold">{{ p.name }}</span>
                <span *ngIf="p.commercialName"
                  class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                  p.commercialName }}</span>
                <!-- El serial distingue dos pedidos del MISMO cliente: sin el, se
                   muestran con el mismo nombre, la misma direccion y —desde que el
                   peso es el correcto— pesos que tambien pueden coincidir. -->
                <span *ngIf="p.serial" class="shrink-0 font-mono text-[10px] text-slate-500">{{ p.serial }}</span>
                <span class="text-slate-500">{{ p.address }}</span>
                <span *ngIf="p.weightLb" class="text-slate-500">
                  · {{ p.weightLb | number: '1.0-1' }} lb
                </span>
                <mat-icon class="icon-size-4 ml-auto shrink-0 self-center text-slate-400 transition-transform"
                  [class.rotate-180]="detailOpenIn('without-route') === p.orderId"
                  svgIcon="heroicons_outline:chevron-down"></mat-icon>
              </div>
              <div *ngIf="detailOpenIn('without-route') === p.orderId && detailOrdersIn('without-route') as detail"
                class="ml-2 flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-3">
                <ng-container *ngTemplateOutlet="ordersDetail; context: { $implicit: detail }"></ng-container>
              </div>
            </ng-container>
          </div>
</ng-template>

<ng-template #unassignedList let-op>
          <!-- No ubicados de la oficina (colapsable) -->
          <div class="rounded-2xl border border-rose-100 bg-rose-50 py-1">
                        <div class="flex flex-col gap-3 px-4 py-3">
              <p class="text-xs text-rose-700">
                Cada ruta se planificó con el camión y la jornada que declara su maestro: lo que quedó
                acá es la capacidad o el tiempo que falta, con el motivo por el que no entró.
              </p>
              <div *ngFor="let g of op.unassignedGroups" class="flex flex-col gap-1.5"
                [hidden]="filterActive && !anyPointMatches(g.items)">
                <span class="text-xs font-semibold text-rose-700">{{ g.label }} · {{ g.items.length }}</span>
                <span *ngIf="g.hint" class="-mt-1 text-xs text-rose-500">{{ g.hint }}</span>
                <!-- Accionable igual que una parada: que se le iba a entregar es la
                   primera pregunta cuando algo NO entro, y hasta ahora el detalle
                   de materiales solo existia para lo que si se entrega. -->
                <ng-container *ngFor="let it of g.items">
                  <div [hidden]="filterActive && !pointMatches(it)"
                    class="flex cursor-pointer items-center gap-3 rounded-md bg-white px-2 py-1.5 ring-1 ring-rose-100 hover:bg-rose-50"
                    [class.bg-rose-50]="detailOpenIn('unassigned') === it.orderId"
                    (click)="toggleDetail('unassigned', it.orderId)">
                    <mat-icon class="icon-size-4 shrink-0 text-rose-400" svgIcon="heroicons_outline:map-pin"></mat-icon>
                    <div class="min-w-0 flex-1">
                      <div class="flex items-center gap-2">
                        <div class="flex min-w-0 items-center gap-1.5">
                          <span class="truncate text-sm font-medium text-slate-800">{{ it.name }}</span>
                          <span *ngIf="it.commercialName"
                            class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                            it.commercialName }}</span>
                        </div>
                        <!-- Rotulado igual que en las paradas: sin la palabra, el
                         valor es indistinguible del nombre de la ruta. -->
                        <span *ngIf="it.territory"
                          class="shrink-0 rounded-full bg-rose-100 px-2 py-0.5 text-[10px] font-semibold text-rose-600">
                          Territorio {{ it.territory }}
                        </span>
                      </div>
                      <div class="text-secondary truncate text-xs">{{ it.address }}</div>
                      <div class="text-xs text-slate-400">
                        <span class="font-medium text-slate-500">
                          {{ it.weightLb | number: '1.0-1' }} lb · {{ it.weightKg | number: '1.0-1' }} kg
                        </span>
                      </div>
                    </div>
                    <mat-icon class="icon-size-4 shrink-0 text-rose-300 transition-transform"
                      [class.rotate-180]="detailOpenIn('unassigned') === it.orderId"
                      svgIcon="heroicons_outline:chevron-down"></mat-icon>
                  </div>
                  <div *ngIf="detailOpenIn('unassigned') === it.orderId && detailOrdersIn('unassigned') as detail"
                    class="mb-1 ml-7 flex flex-col gap-3 rounded-xl border border-rose-100 bg-white p-3">
                    <ng-container *ngTemplateOutlet="ordersDetail; context: { $implicit: detail }"></ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
</ng-template>

<!-- ====== Los PARAMETROS con los que se armo una ruta ======
     Los insumos que se le enviaron al optimizador —capacidad, jornada, viajes,
     ventana y atencion—, cada uno con su procedencia. Se armaban, se enviaban y se
     descartaban, y de eso salia que una capacidad que el maestro NO declara se
     mostrara igual que una real.

     Nombrar los insumos no es reconstruir el motivo: el contrato no informa por que
     el optimizador prefirio una secuencia, pero SI se puede afirmar que entro a la
     peticion.

     El panel va `w-full` DENTRO de la fila —que es `flex-wrap`— para poder vivir en
     la misma pieza compartida que el boton: separarlos obligaria a montar dos cosas
     en cada superficie, que es como la ventana del dia se quedo fuera de una.
     `stopPropagation` porque el encabezado entero colapsa la tarjeta. -->
<ng-template #routeParamsControl let-route>
  <button *ngIf="routeParamsOf(route) as params" type="button"
    (click)="$event.stopPropagation(); toggleRouteParams(route.subRouteId)"
    class="flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold transition-colors"
    [ngClass]="capacityIsAssumed(route)
      ? 'bg-amber-50 text-amber-700 hover:bg-amber-100'
      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'"
    [attr.aria-expanded]="paramsOpenId === route.subRouteId"
    [title]="capacityIsAssumed(route)
      ? 'Con qué se armó esta ruta. Su capacidad es un supuesto: el vehículo no declara peso bruto en el maestro.'
      : 'Con qué se armó esta ruta: capacidad, jornada, viajes, ventana y atención.'">
    <mat-icon class="icon-size-3" svgIcon="heroicons_outline:calculator"></mat-icon>
    parámetros
    <!-- La capacidad supuesta se declara ACA y no en la barra de capacidad: la barra
       esta duplicada entre la tarjeta y el panel del mosaico, y este control es
       compartido. Una marca, cuatro superficies. -->
    <ng-container *ngIf="capacityIsAssumed(route)">· capacidad supuesta</ng-container>
  </button>

  <div *ngIf="paramsOpenId === route.subRouteId && routeParamRowsOf(route) as rows"
    class="w-full rounded-xl border border-slate-200 bg-white p-3">
    <div class="mb-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-500">
      Con qué se armó esta ruta
    </div>
    <div *ngFor="let row of rows" class="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 py-0.5 text-xs">
      <span class="w-36 shrink-0 font-semibold text-slate-700">{{ row.label }}</span>
      <span class="text-slate-800">{{ row.value }}</span>
      <span *ngIf="row.source" class="rounded-full px-2 py-0.5 text-[10px] font-semibold" [ngClass]="row.source === 'master'
          ? 'bg-emerald-50 text-emerald-700'
          : 'bg-amber-50 text-amber-700'">
        {{ paramSourceLabel(row.source) }}
      </span>
      <!-- Un valor ausente dice POR QUE lo esta. Rellenarlo con la jornada afirmaria
         una restriccion que no se envio: la ventana se aplica a los pedidos y la
         jornada al camion. -->
      <span *ngIf="row.note" class="text-secondary text-[11px]">{{ row.note }}</span>
    </div>
  </div>
</ng-template>

<!-- ============ El RECORRIDO DE DECISION de una parada ============
     Que quedo decidido en cada tramo y por que camino se llego ahi. Se enuncia lo
     decidido y NO quien lo decidio: el contrato del motor devuelve rutas y no
     asignadas con motivo, y no informa razones. Un tramo redactado como "el motor
     eligio este camion porque…" seria una reconstruccion nuestra con la autoridad
     de una traza.

     El rotulo dice "parametros" igual que el control de la RUTA, por decision explicita
     del usuario. Son dos paneles distintos —este trae territorio, flota y ubicacion; el
     de la ruta trae capacidad, jornada y atencion— asi que lo que los separa NO es el
     rotulo: es el `title`. El de la parada arranca con el rotulo de su marca; el de la
     ruta con "Con que se armo esta ruta". Si algun dia se busca desambiguarlos por
     texto, este es el lugar.

     La MARCA **ES** el control: el elemento que anuncia que hay una respuesta es el que
     la abre. Antes era un `mat-icon` inerte, con este argumento: "la fila ya es
     accionable y anidar otro control volveria ambiguo el clic". El clic deja de ser
     ambiguo cuando cada control abre algo DISTINTO —el icono el recorrido, la fila lo
     que se entrega—, y `stopPropagation` los separa. Mismo precedente que el boton de
     mapa dentro del encabezado colapsable de la ruta. -->
<ng-template #decisionMark let-d let-id="id">
  <button *ngIf="d" type="button" (click)="$event.stopPropagation(); toggleDecision(id)"
    class="flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold transition-colors"
    [ngClass]="d.markChipClass" [attr.aria-expanded]="decisionOpenId === id"
    [title]="d.markLabel + ' · abrir el recorrido'"
    [attr.aria-label]="d.markLabel + ' · abrir el recorrido'">
    <mat-icon class="icon-size-3" [svgIcon]="d.markIcon"></mat-icon>
    parámetros
  </button>
</ng-template>

<ng-template #decisionTrail let-d>
  <div *ngIf="d && d.steps.length" class="flex flex-col gap-1 rounded-lg bg-white p-3 ring-1 ring-slate-100">
    <div class="flex items-center gap-2">
      <mat-icon class="icon-size-4 shrink-0" [ngClass]="d.markClass" [svgIcon]="d.markIcon"></mat-icon>
      <span class="text-[11px] font-bold uppercase tracking-wide text-slate-500">Cómo quedó en esta ruta</span>
    </div>
    <div *ngFor="let paso of d.steps" class="flex flex-wrap items-baseline gap-x-2 text-xs">
      <span class="font-semibold text-slate-700">{{ paso.what }}</span>
      <span class="text-secondary">{{ paso.how }}</span>
      <!-- Un tramo sin alternativas cierra la pregunta: no hubo eleccion que
         explicar, y eso es una respuesta completa. -->
      <span *ngIf="paso.sole" class="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-500">
        única opción
      </span>
    </div>
  </div>
</ng-template>

<ng-template #truckMetaRow let-t>
  <span>{{ t.stops.length }} paradas</span>
  <span>· {{ t.distanceKm | number: '1.0-1' }} km</span>
  <span [title]="'En ruta ' + formatDuration(t.durationMin) + ' + atención ' + formatDuration(t.serviceMin)">
    · jornada {{ formatDuration(t.workMin) }}
  </span>
  <span class="text-slate-400">({{ formatDuration(t.durationMin) }} en ruta)</span>
  <!-- La ventana del dia, sin tener que expandir la ruta. -->
  <ng-container *ngTemplateOutlet="routeWindow; context: { $implicit: t, sep: true }"></ng-container>
  <!-- Con que se armo la ruta. Va en esta pieza para llegar a la tarjeta y al panel
     del mosaico de una sola vez. -->
  <ng-container *ngTemplateOutlet="routeParamsControl; context: { $implicit: t }"></ng-container>
</ng-template>

<ng-template #routeWindow let-w let-compact="compact" let-sep="sep">
  <span *ngIf="w && (w.departureTime || w.returnArrivalTime)"
    class="flex items-baseline gap-1 whitespace-nowrap"
    [title]="(w.estimated ? 'Estimado. ' : '') +
      'Sale del almacen' + (w.departureTime ? ' a las ' + w.departureTime : ' (hora no derivable)') +
      (w.returnArrivalTime ? ' y regresa a las ' + w.returnArrivalTime : '. La hora de regreso no se puede derivar del plan.')">
    <!-- El separador va DENTRO de la guarda: afuera se pintaba siempre y una ruta sin
       ventana derivable dejaba un `·` colgando al final de la fila. Quien decide si
       hay algo que separar es la misma condicion que decide si hay ventana. -->
    <span *ngIf="sep" class="text-slate-400">·</span>
    <ng-container *ngIf="compact">
      <mat-icon class="icon-size-3 shrink-0 text-slate-400" svgIcon="heroicons_outline:clock"></mat-icon>
      <span>{{ w.estimated ? '≈' : '' }}{{ w.departureTime || '—' }}</span>
      <!-- Sin regreso derivable NO se pone un guion en su lugar: se leeria como "no
         vuelve", que es otra afirmacion. Se omite la flecha entera. -->
      <ng-container *ngIf="w.returnArrivalTime">
        → <span>{{ w.estimated ? '≈' : '' }}{{ w.returnArrivalTime }}</span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!compact">
      <ng-container *ngIf="w.departureTime">
        sale {{ w.estimated ? '≈ ' : '' }}{{ w.departureTime }}
      </ng-container>
      <ng-container *ngIf="w.returnArrivalTime">
        <span *ngIf="w.departureTime">·</span>
        regresa {{ w.estimated ? '≈ ' : '' }}{{ w.returnArrivalTime }}
      </ng-container>
    </ng-container>
  </span>
</ng-template>

<!-- ================= Las piezas de TIEMPO, compartidas =================
     AL NIVEL RAIZ, no dentro del gestor: una `#ref` declarada dentro de un
     `*ngIf` solo existe mientras esa vista existe, asi que con el gestor
     cerrado la lista del resultado las recibia como `undefined` y perdia sus
     filas EN SILENCIO — `ngTemplateOutlet` con undefined no pinta ni falla.
     Las usan la lista del resultado y las dos pestañas del gestor. Tres
     presentaciones del mismo dato divergen a la primera corrección, y el
     síntoma sería que la misma parada se lee distinto según desde dónde se
     la mire — en la pantalla que decide si el camión sale.
     Solo los TIEMPOS: el asa de arrastre, los ↑↓, quitar y el filtro de
     búsqueda son propios de cada lista. -->

<!-- Salida del almacén: el tramo hasta la primera entrega ya está contado en
     la jornada, pero la lista arrancaba en la parada 1 y no decía de dónde
     venía. En un territorio lejano son dos horas y media. -->
<ng-template #routeDepartureRow let-tl>
  <div *ngIf="tl && tl.outboundMin > 0"
    class="mb-1 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-slate-200">
    <span class="flex items-center gap-2 text-xs text-slate-600">
      <mat-icon class="icon-size-4 shrink-0 text-slate-400"
        svgIcon="heroicons_outline:building-office-2"></mat-icon>
      Salida del almacén ·
      <b class="text-slate-800">{{ tl.estimated ? '≈ ' : '' }}{{ formatDuration(tl.outboundMin) }}</b>
      hasta la primera entrega
    </span>
    <span class="text-secondary text-[11px]" *ngIf="tl.departureTime">
      sale {{ tl.estimated ? '≈ ' : '' }}{{ tl.departureTime }}
    </span>
  </div>
</ng-template>

<!-- La columna de horas de una parada. Ausente = no hay tiempos que afirmar,
     y no se pinta nada: un cero sería una afirmación falsa. -->
<ng-template #stopTimeColumn let-t>
  <!-- El `≈` va PEGADO a cada numero, no solo en el encabezado ni en un tooltip: lo
     que distingue una estimacion de un calculo tiene que leerse sin pasar el mouse y
     sin haber leido otra parte de la pantalla.
     El tono mas apagado es la segunda senal, la que se capta sin leer. -->
  <div *ngIf="t" class="shrink-0 text-right text-xs" [class.opacity-75]="t.estimated"
    [title]="t.estimated
      ? 'Estimacion geometrica calibrada con esta corrida. Recalcular la ruta da el numero real.'
      : ''">
    <div *ngIf="t.legDurationMin" class="text-slate-400">
      {{ t.estimated ? '≈ ' : '' }}{{ t.legDurationMin }} min de viaje
    </div>
    <div class="font-medium" [class.text-slate-600]="!t.estimated" [class.text-slate-500]="t.estimated">
      llega {{ t.estimated ? '≈ ' : '' }}{{ t.arrivalTime }}<ng-container *ngIf="t.departureTime"> ·
        sale {{ t.estimated ? '≈ ' : '' }}{{ t.departureTime }}</ng-container>
    </div>
    <div *ngIf="t.serviceMin" class="text-slate-400">atiende {{ t.serviceMin }} min</div>
  </div>
</ng-template>

<!-- El divisor de recarga. Solo aparece si el timeline TRAE recargas: un
     resultado de `Reordenar` llega con `reloads: []` porque `/sort` no modela
     viajes, y ahí el divisor desaparece solo — sin que esta plantilla tenga
     que preguntar de dónde salieron los tiempos. -->
<ng-template #reloadDivider let-rl>
  <div class="my-1 flex items-center gap-2 rounded-lg border border-dashed border-violet-200 bg-violet-50 px-3 py-2">
    <mat-icon class="icon-size-4 text-violet-500" svgIcon="heroicons_outline:arrow-uturn-left"></mat-icon>
    <span class="text-xs font-semibold text-violet-700">
      Recarga en almacén
      <ng-container *ngIf="rl.reload as r">
        — llega {{ r.arrival_time }} · sale {{ r.departure_time }}
      </ng-container>
    </span>
    <span class="ml-auto rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-violet-600">
      Viaje {{ rl.trip }}
    </span>
  </div>
</ng-template>

<!-- Cuánto del día consume una visita. Una sola vez por parada y no por
     pedido: el camión para una vez y descarga todo lo del cliente; repetirlo
     por bloque insinuaría una suma que no ocurre. -->
<ng-template #stopCostBlock let-c>
  <div *ngIf="c.t"
    class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 rounded-lg bg-white px-3 py-2 ring-1 ring-slate-100">
    <span class="text-xs text-slate-600">
      <b class="text-slate-800">{{ c.cost.travelMin }} min</b> de viaje +
      <b class="text-slate-800">{{ c.cost.serviceMin }} min</b> de atención =
      <b class="text-indigo-600">{{ c.cost.totalMin }} min</b>
    </span>
    <span class="text-secondary text-[11px]">
      llega {{ c.t.arrivalTime }}<ng-container *ngIf="c.t.departureTime"> · sale {{ c.t.departureTime }}</ng-container>
      <ng-container *ngIf="c.extra">· {{ c.extra }}</ng-container>
    </span>
  </div>
</ng-template>

<!-- El regreso al almacén: ya estaba contado en la jornada pero no se veía en
     ninguna fila, así que la última parada terminaba a media tarde y las horas
     parecían no cuadrar. En la corrida medida, 151 de 312 minutos de viaje. -->
<ng-template #routeReturnRow let-tl>
  <div *ngIf="tl && tl.returnMin > 0"
    class="mt-1 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-slate-200">
    <span class="flex items-center gap-2 text-xs text-slate-600">
      <mat-icon class="icon-size-4 shrink-0 text-slate-400"
        svgIcon="heroicons_outline:arrow-uturn-left"></mat-icon>
      Regreso al almacén ·
      <b class="text-slate-800">{{ tl.estimated ? '≈ ' : '' }}{{ formatDuration(tl.returnMin) }}</b>
      de viaje
    </span>
    <span class="text-secondary text-[11px]" *ngIf="tl.returnArrivalTime">
      llega {{ tl.estimated ? '≈ ' : '' }}{{ tl.returnArrivalTime }}
    </span>
  </div>
</ng-template>


<ng-template #stopsList let-t>
  <!-- Salida del almacén: el tramo hasta la primera entrega ya estaba contado
                 en la jornada, pero la lista arrancaba en la parada 1 y no decía de
                 dónde venía. En un territorio lejano son dos horas y media, la mitad
                 de lo que ocupa el día. -->
  <!-- La MISMA pieza que usa el gestor. `TruckRouteView` ya tiene los cuatro campos
       que el timeline declara, así que se pasa tal cual: la forma compartida no es
       una conversión, es la que el plan ya producía. -->
  <ng-container *ngTemplateOutlet="routeDepartureRow; context: { $implicit: t }"></ng-container>

  <ng-container *ngFor="let s of t.stops; let i = index">
    <ng-container *ngIf="stopMatches(s)">
      <ng-container *ngIf="i > 0 && s.trip !== t.stops[i - 1].trip">
        <ng-container
          *ngTemplateOutlet="reloadDivider; context: { $implicit: { reload: t.reloads[s.trip - 2], trip: s.trip } }"></ng-container>
      </ng-container>
      <!-- La parada es accionable: expande qué se le entrega. -->
      <div class="flex cursor-pointer items-center gap-3 rounded-md px-2 py-1.5 hover:bg-slate-50"
        [class.bg-slate-50]="detailOpenIn('stops') === s.orderId" (click)="toggleDetail('stops', s.orderId)">
        <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white"
          [style.background-color]="t.color">{{ s.sequence }}</div>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <div class="flex min-w-0 items-center gap-1.5">
              <span class="truncate text-sm font-medium text-slate-800">{{ s.name }}</span>
              <span *ngIf="s.commercialName"
                class="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold text-slate-600">{{
                s.commercialName }}</span>
              <!-- Al FINAL del nombre y no delante: es un control, no un prefijo del
                 cliente. `shrink-0` para que el nombre trunque antes que el chip. -->
              <ng-container *ngTemplateOutlet="decisionMark; context: { $implicit: stopDecisionOf(s, t), id: s.orderId }"></ng-container>
            </div>
          </div>
          <!-- Ruta y territorio rotulados: comparten número y se
                       distinguen por el prefijo (ENTREGA 809 / TEGUCIGALPA 809),
                       así que un valor suelto es indistinguible del otro. -->
          <div *ngIf="s.routeName || s.territory" class="flex flex-wrap items-center gap-1.5 text-[10px]">
            <span *ngIf="s.routeName" class="rounded-full bg-slate-100 px-2 py-0.5 font-semibold text-slate-600">
              Ruta {{ s.routeName }}
            </span>
            <span *ngIf="s.territory" class="rounded-full px-2 py-0.5 font-semibold"
              [class.bg-indigo-50]="!s.territoryMismatch" [class.text-indigo-600]="!s.territoryMismatch"
              [class.bg-amber-50]="s.territoryMismatch" [class.text-amber-700]="s.territoryMismatch" [title]="s.territoryMismatch
                        ? 'Este territorio no está entre los que declara la ruta: revisar la asignación en el maestro.'
                        : 'Territorio de la entrega, declarado por esta ruta.'">
              <ng-container *ngIf="s.territoryMismatch">⚠ </ng-container>Territorio {{ s.territory }}
            </span>
          </div>
          <div class="text-secondary truncate text-xs">{{ s.address }}</div>
          <div class="text-xs text-slate-400">
            <span class="font-medium text-slate-500">
              {{ s.weightLb | number: '1.0-1' }} lb · {{ s.weightKg | number: '1.0-1' }} kg
            </span>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="stopTimeColumn; context: { $implicit: s }"></ng-container>
        <mat-icon class="icon-size-4 shrink-0 text-slate-400 transition-transform"
          [class.rotate-180]="detailOpenIn('stops') === s.orderId" svgIcon="heroicons_outline:chevron-down"></mat-icon>
      </div>

      <!-- El recorrido, en su propio panel y con su propio estado: cerrado no ocupa
           nada. Hermano de la fila y no hijo, porque la fila no envuelve. -->
      <div *ngIf="decisionOpenId === s.orderId" class="mb-2 ml-9">
        <ng-container *ngTemplateOutlet="decisionTrail; context: { $implicit: stopDecisionOf(s, t) }"></ng-container>
      </div>

      <!-- Detalle: un bloque por pedido. Una visita puede agrupar varios
                   pedidos del mismo cliente, y los pesos de los bloques suman el
                   de la parada — si mostráramos solo el primero, no cerraría. -->
      <div *ngIf="detailOpenIn('stops') === s.orderId && detailOrdersIn('stops') as detail"
        class="mb-2 ml-9 flex flex-col gap-3 rounded-xl border border-slate-100 bg-slate-50/60 p-3">
        <!-- Costo de tiempo de la VISITA: una sola vez, no por pedido.
                     El camión para una vez y descarga todos los pedidos del
                     cliente; repetirlo por bloque insinuaría una suma que no
                     ocurre. El peso sí se reparte, el tiempo no. -->
        <ng-container
          *ngTemplateOutlet="stopCostBlock; context: { $implicit: {
            t: s,
            cost: stopCostOf(s, i),
            extra: detail.orders.length + ' pedido' + (detail.orders.length === 1 ? '' : 's')
          } }"></ng-container>

        <div *ngIf="detail.split"
          class="flex items-start gap-2 rounded-lg border border-amber-100 bg-amber-50 px-3 py-2">
          <mat-icon class="icon-size-4 shrink-0 text-amber-500"
            svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
          <span class="text-xs text-amber-900">
            Esta visita está <b>dividida por capacidad</b>: el detalle corresponde al cliente
            completo, no solo a esta parte.
          </span>
        </div>

        <div *ngIf="!detail.orders.length" class="text-xs text-slate-500">
          No se encontraron los pedidos de esta parada.
        </div>

        <div *ngFor="let o of detail.orders" class="flex flex-col gap-1">
          <div class="flex items-baseline justify-between gap-3 px-1">
            <span class="text-xs font-bold text-slate-700">Pedido {{ o.serial }}</span>
            <span class="text-xs font-medium text-slate-500">
              {{ o.weightLb | number: '1.0-1' }} lb
            </span>
          </div>
          <app-order-details-table *ngIf="o.detail.length; else noMaterials" [detailData]="o.detail"
            [UMPActive]="data.UMPActive ?? false"></app-order-details-table>
          <ng-template #noMaterials>
            <span class="px-1 text-xs text-slate-400">Sin materiales en el pedido.</span>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- El regreso al almacén: ya estaba contado en la jornada (el camión sale
                 y vuelve al almacén) pero no se veía en ninguna fila, así que la última
                 parada terminaba a media tarde y las horas parecían no cuadrar. En un
                 territorio lejano son horas: en la corrida medida, 151 de los 312
                 minutos de viaje. -->
  <ng-container *ngTemplateOutlet="routeReturnRow; context: { $implicit: t }"></ng-container>
</ng-template>